import { React, useState, useEffect, useRef } from "react";
import styled from "styled-components";
import {
  Layout,
  Row,
  Col,
  Button,
  PageHeader,
  Checkbox,
  Form,
  Select,
  Input,
  Radio,
  Tooltip,
  Table,
  Skeleton,
} from "antd";
import {
  RightLayoutContainer,
  OtherPages,
  PageTitleComp,
  HaberForm,
  RightDrawerContainer,
  DownArrowDraw,
  DetailFields,
  DropDownSearchDraw,
  TableLayoutData,
} from "../styledElements";
import logoCompany from "../../Assets/Images/logo.svg";
import Iconmoon from "../../Components/IconsFiles/icon";
import * as htmlToImage from "html-to-image";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { useNavigate, useLocation } from "react-router";
import moment from "moment";
import { getExportParentReelDetails } from "../../Services/productionPlanningServices";
import { useReactToPrint } from "react-to-print";
import {
  getJobCardCylinders,
  getJobCardsById,
  getDeckleFormats,
  saveDefaultSelectionForJobCardPrint,
} from "../../Services/deckleMatchServices";
import { getCompanyDetails } from "../../Services/companyServices";
import {
  PaperMachineRecordsData,
  PaperMachineScroll,
  GlobalSet,
  Styled,
} from "../pageStyled";
import { Switch } from "antd";
import { convertDate, toHandlePOName } from "../../Utils/helper/helper";
import SimpleBar from "simplebar-react";
import "simplebar/dist/simplebar.min.css";
import { getWorkflowSettings } from "../../Services/workFlowSettingsServices";
import {
  lengthUnit,
  weightUnit,
  currency_List,
  CoversionFactorUnitsToCM,
  conversionFactorUnitsToTonne,
  conversionFactorTonneToUnits,
} from "../../Utils/Constant/MeasurementUnitList.jsx";
import { getUnitData } from "../../Services/measurementService";
import TableShimmer from "../../Components/TableShimmer/tableShimmer.jsx";

const capitalize = (item) => item.charAt(0).toUpperCase() + item.slice(1);

const CardShimmerStyle = styled.div`
  .ant-card-body {
    position: relative;
    z-index: 0;
    overflow: hidden;
    height: 100%;
    padding: 0px;
  }
  .ant-skeleton-element .ant-skeleton-button {
    min-width: 0px;
    width: 100%;
    border-radius: 3px;
  }
  .ant-skeleton-element .ant-skeleton-input {
    min-width: 0px;
    width: 100%;
    border-radius: 3px;
  }
  .ant-skeleton-element {
    width: 100%;
  }
  .table {
    border: 0px solid #eeeeee !important;
  }
`;

const PrintData = styled.div`
  padding: 0px;
  margin: 40px auto;
  background-color: #fff;
  width: 845px;
`;

const ExportHeader = styled.div`
  background-color: #faf9f8;
  padding: 10px 15px;
  .file-header {
    display: flex;
    justify-content: space-between;
  }
  .file-header-logo {
    width: 130px;
    display: flex;
    img {
      width: 100%;
      align-self: center;
    }
  }
  .client-name {
    width: 27%;
  }
  .client-name h4 {
    font-size: 12px;
    font-family: var(--sf-pro-display-m);
    margin: 0px;
  }
  .client-name h6 {
    font-style: italic;
    color: #605e5c;
    font-size: 10px;
    margin: 0px;
  }
  .client-data {
    display: flex;
    > div {
      width: 50%;
      label {
        color: #000;
        font-size: 9px;
        font-family: var(--sf-pro-display-m);
        display: block;
      }
      span {
        color: #605e5c;
        font-size: 9px;
        font-family: var(--sf-pro-display-m);
        display: block;
      }
    }
  }
`;

const ExportTable = styled.div`
  table {
    width: 100%;
    border: 1px solid #000;
  }
  thead th {
    border: 1px solid #000;
  }
  td {
    border: 1px solid #000;
  }

  th,
  td {
    text-align: center;
    padding: 5px 5px;
  }
  th {
    text-transform: uppercase;
    font-size: 10px;
    line-height: 1.2;
    font-weight: 700;
    font-family: var(--sf-pro-text);
  }
  p {
    margin: 0;
    font-family: var(--sf-pro-text);
  }
  .order-d {
    p {
      text-transform: uppercase;
      font-size: 7px;
      font-weight: 600;
    }
    .order-d-l {
      p {
        text-transform: none;
        color: #605e5c;
        font-size: 7px;
        font-weight: 400;
      }
    }
  }
  .date {
    color: #000;
    font-size: 8px;
    font-weight: 600;
  }
  .p-detail {
    font-size: 7px;
    font-weight: 600;
    color: #605e5c;
  }
  .factor {
    color: #000;
    font-size: 7px;
    font-weight: 600;
    font-style: italic;
  }
  .p-ton {
    font-size: 8px;
    font-weight: 600;
    color: #000;
  }
  .reel {
    font-size: 8px;
    color: #605e5c;
    font-style: italic;
  }
  .remark {
    font-size: 8px;
    color: #000000;
    font-weight: 500;
    max-width: 110px;
    line-height: 1.2;
  }
  .address {
    font-size: 8px;
    color: #000000;
    font-weight: 500;
    max-width: 170px;
    line-height: 1.2;
  }
  .ms-2 {
    width: 50px;
  }
  .f-10 {
    font-size: 10px !important;
  }
  .f-11 {
    font-size: 11px !important;
    font-weight: 600 !important;
  }
  .f-12-bold {
    font-size: 12px !important;
    font-weight: bold;
  }
`;

const ExportTableForm1 = styled.div`
  table {
    width: 100%;
    border-bottom: 1px solid #000;
  }
  thead th {
    border-top: 1px solid #000;
  }
  td {
    border-top: 1px solid #000;
  }

  th,
  td {
    text-align: center;
    padding: 5px 5px;
  }
  th {
    text-transform: uppercase;
    font-size: 10px;
    line-height: 1.2;
    font-weight: 700;
    font-family: var(--sf-pro-text);
  }
  .productTd {
    td {
      border-top: 0px solid #000;
    }
  }
  p {
    margin: 0;
    font-family: var(--sf-pro-text);
  }
  .order-d {
    p {
      text-transform: uppercase;
      font-size: 7px;
      font-weight: 600;
    }
    .order-d-l {
      p {
        text-transform: none;
        color: #605e5c;
        font-size: 7px;
        font-weight: 400;
      }
    }
  }
  .date {
    color: #000;
    font-size: 8px;
    font-weight: 600;
  }
  .p-detail {
    font-size: 7px;
    font-weight: 600;
    color: #605e5c;
  }
  .factor {
    color: #000;
    font-size: 7px;
    font-weight: 600;
    font-style: italic;
  }
  .p-ton {
    font-size: 8px;
    font-weight: 600;
    color: #000;
  }
  .reel {
    font-size: 8px;
    color: #605e5c;
    font-style: italic;
  }
  .reelForFormat2 {
    font-size: 10px;
    color: #605e5c;
    font-style: italic;
  }
  .remark {
    font-size: 8px;
    color: #000000;
    font-weight: 500;
    max-width: 110px;
    line-height: 1.2;
  }
  .address {
    font-size: 8px;
    color: #000000;
    font-weight: 500;
    max-width: 170px;
    line-height: 1.2;
  }
  .ms-2 {
    width: 50px;
  }
  .f-10 {
    font-size: 10px !important;
  }
  .f-11 {
    font-size: 11px !important;
    font-weight: 600 !important;
  }
  .f-12-bold {
    font-size: 12px !important;
    font-weight: bold;
  }
  .priority {
    background: #e0e2e8;
  }
`;

const ExportAdditional = styled.div`
  background-color: #e0e2e8;
  padding: 25px 15px 20px;
  margin: 20px 0;
  .export-additional {
    display: flex;
    flex-wrap: wrap;
    .additional-col {
      flex: 0 0 33.3%;
      max-width: 33.3%;
    }
    .additional-col-format-1 {
      flex: 0 0 33.3%;
      max-width: 24%;
    }
  }
  }
  .additional-col-format-1{
    label,
    p {
      font-family: var(--sf-pro-display-m);
      color: #3b3a39;
      line-height: 15px;
      margin-bottom: 6px;
      font-size: 12px;
    }
    label {
      font-size: 14px;
    }
  }
  .additional-col {
    label,
    p {
      font-family: var(--sf-pro-display-m);
      color: #3b3a39;
      line-height: 15px;
      margin-bottom: 6px;
      font-size: 12px;
    }
    label {
      font-size: 14px;
    }
  }
`;

const ExportNote = styled.div`
  background-color: #e0e2e8;
  padding: 8px 15px 6px;
  margin: 20px 0;
  .export-additional {
    display: flex;
    flex-wrap: wrap;
    .additional-col {
      flex: 0 0 33.3%;
      max-width: 33.3%;
    }
  }
`;

function addScript(url) {
  const script = document.createElement("script");
  script.type = "application/javascript";
  script.src = url;
  document.head.appendChild(script);
}

addScript(
  "https://raw.githack.com/eKoopmans/html2pdf/master/dist/html2pdf.bundle.js"
);

const PrintSheetJobCardDetails = (props) => {
  const [jobCardSummary, setJobCardSummary] = useState();
  const [jobCardDetails, setJobCardDetails] = useState();
  const [jobCardDetailsFormat1, setJobCardDetailsFormat1] = useState();
  const [showLoader, setLoader] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [jobId, setJobId] = useState(props?.jobId ?? location?.state?.jobId);
  const [jobCardCode, setJobCardCode] = useState(props?.jobcardCode ?? location?.state?.jobcardCode);
  const [orderDetailsList, setOrderDetailsList] = useState(
    (props?.orderDetailsList ?? location?.state?.orderDetailsList)?.map((item) => {
      if (item.category === "so") {
        return {
          ...item,
          pono: toHandlePOName(item.sono),
          consignee_code: "SO",
          consignee_name: "SO",
          customer_alias: "SO",
          customername: "SO",
          customercode: "SO",
        };
      } else {
        return {
          ...item,
          pono: toHandlePOName(item.pono),
        };
      }
    })
  );
  const [solution, setSolution] = useState(`solution_${props?.solution ?? location?.state?.solution}`);
  const [solutionGroup, setSolutionGroup] = useState(`sol_${props?.solution ?? location?.state?.solution}_groups`);
  const [company, setCompany] = useState();
  const [totalSets, setTotalSets] = useState(0);

  const timeElapsed = Date.now();
  const today = new Date(timeElapsed);
  const printRef = useRef();
  const orderDetails = useRef([]);
  const customerWiseOrderDetails = useRef([]);
  const sizeWiseOrderDetails = useRef([]);
  const [formatTab, setFormatTab] = useState();
  const [selectedFormat, setSelectedFormat] = useState();
  const [checkboxValue, setCheckBoxValue] = useState(false);
  const [edgeTrim, setEdgeTrim] = useState(false);
  const [netTrim, setNetTrim] = useState(false);
  const [deliveryDate, setDeliveryDate] = useState(false);
  const [customerDetails, setCustomerDetails] = useState(false);
  const [productDetails, setProductDetails] = useState(false);
  const [orderRemarks, setOrderRemarks] = useState(false);
  const [formatData, setFormatData] = useState([]);
  const [orderWidthArr, setOrderWidthArr] = useState([]);
  const [jobCardCylinderResponse, setJobCardCylinderResponse] = useState();
  const acceptedSolution = props?.acceptedSolution ?? location?.state?.acceptedSolution;
  const [productWiseOrder, setProductWiseOrder] = useState([]);
  const [customerWiseOrder, setCustomerWiseOrder] = useState([]);
  const [consigneeWiseOrder, setConsigneeWiseOrder] = useState([]);
  const [poWiseOrder, setPoWiseOrder] = useState([]);
  const [sheetOrder, setSheetOrder] = useState();
  const jobCard = props?.jobCard ?? location?.state?.jobCard;
  const [msgVisible, setMsgVisible] = useState(false);
  const [unitData, setUnitData] = useState();
  const [consigneeDetails, setConsigneeDetails] = useState(false);
  const [poDetails, setPoDetails] = useState(false);

  const shimmerHeader = [
    {
      title: "Size(WxL)",
      dataIndex: "size",
    },
    {
      title: "Size(WxL)",
      dataIndex: "size",
    },
    {
      title: "Size(WxL)",
      dataIndex: "size",
    },
    {
      title: "Size(WxL)",
      dataIndex: "size",
    },
    {
      title: "Size(WxL)",
      dataIndex: "size",
    },
  ];

  const getPageMargins = () => {
    return `@page { margin: 70px 30px 70px 30px !important; }`;
  };

  const dataSet =
    acceptedSolution.solution &&
    acceptedSolution.solution.partitions?.map((item, index) => {
      let totalWidth = 0;
      let totalWeight = 0;
      let widthData = [];

      item.partition.forEach((current) => {
        widthData.push({
          width: current.breadth,
          priority: current.priority,
          type: current.type,
        });
        totalWidth = totalWidth + current.breadth;
        totalWeight = totalWeight + current.weight;
        //ordersToShowInTable[+(index + 1)] = current?.breadth
      });

      let burstFactorWiseInfo = [];
      let uniqueOrder = item.partition.map((data) => data.order_id);
      uniqueOrder = [...new Set(uniqueOrder)];
      for (let orderIndex = 0; orderIndex < uniqueOrder.length; orderIndex++) {
        const order = uniqueOrder[orderIndex];
        let orderDetails = orderDetailsList.find((obj) => {
          return obj.orderno == order;
        });

        let productDetails = burstFactorWiseInfo.find((obj) => {
          return (
            obj.burst_factor == orderDetails.productInfo.burst_factor &&
            obj.gsm == orderDetails.productInfo.gsm
          );
        });
        if (productDetails) {
          let orderInfo = productDetails.orders.find((obj) => {
            return obj.orderno == orderDetails.orderno;
          });
          if (!orderInfo) {
            let totalsheet = item.partition.filter(
              (data) => data.order_id === orderDetails.orderno
            );
            orderDetails["totalSheet2"] = totalsheet.length * item.repeated;
            orderDetails["group"] =
              orderDetails.grain.toLowerCase() === "short" ? "SG" : "LG";
            let indexOfData = burstFactorWiseInfo.findIndex(
              (i) =>
                i.burst_factor == orderDetails.productInfo.burst_factor &&
                i.gsm == orderDetails.productInfo.gsm
            );
            burstFactorWiseInfo[indexOfData].orders.push(orderDetails);
          }
        } else {
          let totalsheet = item.partition.filter(
            (data) => data.order_id == orderDetails.orderno
          );
          orderDetails["totalSheet2"] = totalsheet.length * item.repeated;
          orderDetails["group"] =
            orderDetails.grain.toLowerCase() === "short" ? "SG" : "LG";
          burstFactorWiseInfo.push({
            burst_factor: orderDetails.productInfo.burst_factor,
            gsm: orderDetails.productInfo.gsm,
            orders: [orderDetails],
          });
        }
      }

      let ordersToShowInTable = {
        key: index + 1,
        totalWidth: totalWidth,
        trim: item.trim_loss_width,
        deldate: moment(item.deadline).format("DD MMM YYYY"),
        weight: totalWeight.toFixed(3),
        widthData,
        leftTrim: jobCard.group.machines[0].left_edge_trim,
        rightTrim: jobCard.group.machines[0].right_edge_trim,
        chop: item.length,
        netTrim: 34,
        deliveryDate: item.deadline,
        quantity: item.repeated,
        burstFactorWiseInfo: burstFactorWiseInfo,
        units: item.units,
      };

      return ordersToShowInTable;
    });

  const handleFormatChange = (e) => {
    // let formatArr = formatData.filter((format => format.value ));
    // if(formatArr?.length && formatArr[0]?.name === e.target.value){
    //   setSelectedFormat(formatArr[0].name);
    //   setCheckBoxValue(formatArr[0].value);
    // } else{
    setSelectedFormat(e.target.value);
    // setCheckBoxValue(false);
    // }
  };

  const printButtonClick = async () => {
    if (checkboxValue) {
      let request = {
        formats: [
          {
            name: "format_1",
            value: selectedFormat == "format_1" ? true : false,
          },
          {
            name: "format_2",
            value: selectedFormat == "format_2" ? true : false,
          },
        ],
      };

      if (selectedFormat == "format_1") {
        request.formats[0]["keys"] = {
          edge_trim: edgeTrim,
          net_trim: netTrim,
          delivery_date: deliveryDate,
          customer_details: customerDetails,
          product_details: productDetails,
          order_remarks: orderRemarks,
          po_details: poDetails,
          consignee_details: consigneeDetails,
        };
      }
      await saveDefaultSelectionForJobCardPrint(request)
        .then((response) => {
          let temp = response;
          handlePrint();
          // setCities(State.getStatesOfCountry("India"));
        })
        .catch((error) => console.log(error));
    } else {
      handlePrint();
    }
  };

  const handlePrint = useReactToPrint({
    content: () => printRef.current,
  });

  const saveFormatCheckbox = (e) => {
    setCheckBoxValue(e.target.checked);
  };

  const edgeTrimHandler = (e) => {
    setEdgeTrim(e);
  };

  const netTrimHandler = (e) => {
    setNetTrim(e);
  };

  const deliveryDateHandler = (e) => {
    setDeliveryDate(e);
  };

  const customerDetailsHandler = (e) => {
    setCustomerDetails(e);
  };

  const productDetailsHandler = (e) => {
    setProductDetails(e);
  };

  const orderRemarksHandler = (e) => {
    setOrderRemarks(e);
  };

  const consingeeDetailsHandler = (e) => {
    setConsigneeDetails(e);
  };

  const poDetailsHandler = (e) => {
    setPoDetails(e);
  };

  const setCompanyDetails = () => {
    getCompanyDetails()
      .then((response) => {
        setCompany(response.data);
      })
      .catch((error) => console.log("Error", error));
  };

  useEffect(() => {
    (async () => {
      let deckleMangtSettings = await getWorkflowSettings("deckle_management");

      let max = acceptedSolution.solution.partitions[0].partition.length;
      for (
        let index = 0;
        index < acceptedSolution.solution.partitions.length;
        index++
      ) {
        const data = acceptedSolution.solution.partitions[index];
        if (data.partition.length > max) max = data.partition.length;
      }
      let sizeArray = [];
      for (let index = 0; index < max; index++) {
        const element = max;
        sizeArray.push(index + 1);
      }
      setOrderWidthArr(sizeArray);
      const allProduct = orderDetailsList.map((order) => order.productInfo);

      const uniqueProduct = allProduct.filter(
        (a, i) =>
          allProduct.findIndex(
            (s) =>
              a.burst_factor === s.burst_factor &&
              a.gms === s.gms &&
              a.grade === s.grade &&
              a.quality === s.quality &&
              a.moisture === s.moisture
          ) === i
      );

      if (
        uniqueProduct.length > 1 &&
        deckleMangtSettings.data.merging.grade_qualities.value
      ) {
        setMsgVisible(true);
      }
      {
      }
      //const uniqueProduct = [...new Set(allProduct)];
      console.log(uniqueProduct);
      let filteredOrder;
      if (productDetails) {
        for (let index = 0; index < uniqueProduct.length; index++) {
          const product = uniqueProduct[index];
          let filteredProductOrder = orderDetailsList.filter(
            (order) =>
              order.productInfo.gsm === product.gsm &&
              order.productInfo.burst_factor === product.burst_factor &&
              order.productInfo.quality === product.quality &&
              order.productInfo.grade === product.grade &&
              order.productInfo.moisture === product.moisture
          );
          let uniqueSize = filteredProductOrder.filter(
            (a, i) =>
              filteredProductOrder.findIndex(
                (s) =>
                  a.width === s.width &&
                  a.length === s.length &&
                  a.grain === s.grain
              ) === i
          );
          let orders = [];
          for (let sizeIndex = 0; sizeIndex < uniqueSize.length; sizeIndex++) {
            const size = uniqueSize[sizeIndex];
            let uniqueOrderSize = filteredProductOrder.filter(
              (a) =>
                a.width === size.width &&
                a.length === size.length &&
                a.grain === size.grain
            );

            if (customerDetails) {
              if (consigneeDetails && poDetails) {
                filteredOrder = uniqueOrderSize.filter(
                  (a, i) =>
                    uniqueOrderSize.findIndex(
                      (s) =>
                        a.consignee_code === s.consignee_code &&
                        a.customercode === s.customercode &&
                        a.pono === s.pono
                    ) === i
                );
              } else if (poDetails) {
                filteredOrder = uniqueOrderSize.filter(
                  (a, i) =>
                    uniqueOrderSize.findIndex(
                      (s) =>
                        a.pono === s.pono && a.customercode === s.customercode
                    ) === i
                );
              } else if (poDetails) {
                filteredOrder = uniqueOrderSize.filter(
                  (a, i) =>
                    uniqueOrderSize.findIndex(
                      (s) =>
                        a.pono === s.pono && a.customercode === s.customercode
                    ) === i
                );
              } else {
                filteredOrder = uniqueOrderSize.filter(
                  (a, i) =>
                    uniqueOrderSize.findIndex(
                      (s) => a.customercode === s.customercode
                    ) === i
                );
              }
            } else if (consigneeDetails) {
              if (poDetails) {
                filteredOrder = uniqueOrderSize.filter(
                  (a, i) =>
                    uniqueOrderSize.findIndex(
                      (s) =>
                        a.consignee_code === s.consignee_code &&
                        a.pono === s.pono
                    ) === i
                );
              } else {
                filteredOrder = uniqueOrderSize.filter(
                  (a, i) =>
                    uniqueOrderSize.findIndex(
                      (s) => a.consignee_code === s.consignee_code
                    ) === i
                );
              }
            } else if (poDetails) {
              filteredOrder = uniqueOrderSize.filter(
                (a, i) =>
                  uniqueOrderSize.findIndex((s) => a.pono === s.pono) === i
              );
            } else {
              filteredOrder = [...uniqueOrderSize];
            }
            if (consigneeDetails || customerDetails || poDetails) {
              for (
                let orderIndex = 0;
                orderIndex < filteredOrder.length;
                orderIndex++
              ) {
                const order = filteredOrder[orderIndex];
                let filteredUniqueOrder = [];
                if (consigneeDetails && customerDetails && poDetails) {
                  filteredUniqueOrder = uniqueOrderSize.filter(
                    (a) =>
                      order.consignee_code === a.consignee_code &&
                      order.customercode === a.customercode &&
                      order.pono === a.pono
                  );
                } else if (consigneeDetails && customerDetails) {
                  filteredUniqueOrder = uniqueOrderSize.filter(
                    (a) =>
                      order.consignee_code === a.consignee_code &&
                      order.customercode === a.customercode
                  );
                } else if (consigneeDetails && poDetails) {
                  filteredUniqueOrder = uniqueOrderSize.filter(
                    (a) =>
                      order.consignee_code === a.consignee_code &&
                      order.pono === a.pono
                  );
                } else if (customerDetails && poDetails) {
                  filteredUniqueOrder = uniqueOrderSize.filter(
                    (a) =>
                      order.customercode === a.customercode &&
                      order.pono === a.pono
                  );
                } else if (consigneeDetails) {
                  filteredUniqueOrder = uniqueOrderSize.filter(
                    (a) => order.consignee_code === a.consignee_code
                  );
                } else if (customerDetails) {
                  filteredUniqueOrder = uniqueOrderSize.filter(
                    (a) => order.customercode === a.customercode
                  );
                } else if (poDetails) {
                  filteredUniqueOrder = uniqueOrderSize.filter(
                    (a) => order.pono === a.pono
                  );
                }

                let totalSheet = 0;
                let remarks = [];
                for (
                  let uniqueIndex = 0;
                  uniqueIndex < filteredUniqueOrder.length;
                  uniqueIndex++
                ) {
                  const uniqueOrderData = filteredUniqueOrder[uniqueIndex];
                  if (uniqueOrderData.remarks) {
                    remarks.push(uniqueOrderData.remarks);
                  }
                  for (
                    let partionIndex = 0;
                    partionIndex < acceptedSolution.solution.partitions.length;
                    partionIndex++
                  ) {
                    const partitions =
                      acceptedSolution.solution.partitions[partionIndex];
                    let filteredPartition = partitions.partition.filter(
                      (partition) =>
                        partition.order_id == uniqueOrderData.orderno
                    );
                    totalSheet =
                      totalSheet +
                      filteredPartition.length * partitions.repeated;
                  }
                }
                let WeightSum = 0;
                let uniquePO = filteredUniqueOrder.filter(
                  (a, i) =>
                    filteredUniqueOrder.findIndex((s) => a.pono === s.pono) ===
                    i
                );
                let po = "";

                uniquePO.map((item, index) => {
                  po =
                    po + item.pono + (index < uniquePO.length - 1 ? ", " : "");
                });

                filteredUniqueOrder.map((item) => {
                  WeightSum += Number(item.fWeight);
                });
                let orderData = {
                  totalSheet: totalSheet,
                  customername: filteredUniqueOrder[0].customername,
                  consignee_name: filteredUniqueOrder[0].consignee_name,
                  group:
                    filteredUniqueOrder[0].grain.toLowerCase() === "short"
                      ? "SG"
                      : "LG",
                  length: filteredUniqueOrder[0].length,
                  width: filteredUniqueOrder[0].width,
                  units: filteredUniqueOrder[0].units,
                  size: filteredUniqueOrder[0].size,
                  productInfo: filteredUniqueOrder[0].productInfo,
                  no_of_sheets: filteredUniqueOrder[0].no_of_sheets,
                  fulfilledWeight: WeightSum.toFixed(3),
                  pono: filteredUniqueOrder[0].pono,
                  type: filteredUniqueOrder[0].type,
                  fWeightUnit: filteredUniqueOrder[0].fWeightUnit,
                  remarks: remarks,
                };
                orders.push(orderData);
              }
            } else {
              let totalSheet = 0;
              let remarks = [];
              for (
                let orderIndex = 0;
                orderIndex < filteredOrder.length;
                orderIndex++
              ) {
                const order = filteredOrder[orderIndex];
                if (order.remarks) {
                  remarks.push(order.remarks);
                }
                for (
                  let partionIndex = 0;
                  partionIndex < acceptedSolution.solution.partitions.length;
                  partionIndex++
                ) {
                  const partitions =
                    acceptedSolution.solution.partitions[partionIndex];
                  let filteredPartition = partitions.partition.filter(
                    (partition) => partition.order_id == order.orderno
                  );
                  totalSheet =
                    totalSheet + filteredPartition.length * partitions.repeated;
                }
              }
              let WeightSum = 0;
              filteredOrder.map((item) => {
                WeightSum += Number(item.fWeight);
              });
              let uniquePO = filteredOrder.filter(
                (a, i) =>
                  filteredOrder.findIndex((s) => a.pono === s.pono) === i
              );
              let po = "";

              uniquePO.map((item, index) => {
                po = po + item.pono + (index < uniquePO.length - 1 ? ", " : "");
              });
              let orderData = {
                totalSheet: totalSheet,
                customername: filteredOrder[0].customername,
                consignee_name: filteredOrder[0].consignee_name,
                group:
                  filteredOrder[0].grain.toLowerCase() === "short"
                    ? "SG"
                    : "LG",
                length: filteredOrder[0].length,
                width: filteredOrder[0].width,
                units: filteredOrder[0].units,
                size: filteredOrder[0].size,
                productInfo: filteredOrder[0].productInfo,
                no_of_sheets: filteredOrder[0].no_of_sheets,
                fulfilledWeight: WeightSum.toFixed(3),
                pono: po,
                type: filteredOrder[0].type,
                fWeightUnit: filteredOrder[0].fWeightUnit,
                remarks: remarks,
              };
              orders.push(orderData);
            }
          }

          uniqueProduct[index]["orders"] = orders;
        }

        setProductWiseOrder(uniqueProduct);
      } else if (customerDetails) {
        let uniqueSize = orderDetailsList.filter(
          (a, i) =>
            orderDetailsList.findIndex(
              (s) =>
                a.width === s.width &&
                a.length === s.length &&
                a.grain === s.grain
            ) === i
        );
        let orders = [];
        for (let sizeIndex = 0; sizeIndex < uniqueSize.length; sizeIndex++) {
          const size = uniqueSize[sizeIndex];
          let uniqueOrderSize = orderDetailsList.filter(
            (a) =>
              a.width === size.width &&
              a.length === size.length &&
              a.grain === size.grain
          );

          if (customerDetails) {
            if (consigneeDetails) {
              if (poDetails) {
                filteredOrder = uniqueOrderSize.filter(
                  (a, i) =>
                    uniqueOrderSize.findIndex(
                      (s) =>
                        a.consignee_code === s.consignee_code &&
                        a.customercode === s.customercode &&
                        a.pono === s.pono
                    ) === i
                );
              } else {
                filteredOrder = uniqueOrderSize.filter(
                  (a, i) =>
                    uniqueOrderSize.findIndex(
                      (s) =>
                        a.consignee_code === s.consignee_code &&
                        a.customercode === s.customercode
                    ) === i
                );
              }
            } else if (poDetails) {
              filteredOrder = uniqueOrderSize.filter(
                (a, i) =>
                  uniqueOrderSize.findIndex(
                    (s) =>
                      a.customercode === s.customercode && a.pono === s.pono
                  ) === i
              );
            } else {
              filteredOrder = uniqueOrderSize.filter(
                (a, i) =>
                  uniqueOrderSize.findIndex(
                    (s) => a.customercode === s.customercode
                  ) === i
              );
            }
          }

          for (
            let orderIndex = 0;
            orderIndex < filteredOrder.length;
            orderIndex++
          ) {
            const order = filteredOrder[orderIndex];
            let filteredUniqueOrder = [];
            if (consigneeDetails && customerDetails && poDetails) {
              filteredUniqueOrder = uniqueOrderSize.filter(
                (a) =>
                  order.consignee_code === a.consignee_code &&
                  order.customercode === a.customercode &&
                  order.pono === a.pono
              );
            } else if (consigneeDetails && customerDetails) {
              filteredUniqueOrder = uniqueOrderSize.filter(
                (a) =>
                  order.consignee_code === a.consignee_code &&
                  order.customercode === a.customercode
              );
            } else if (customerDetails && poDetails) {
              filteredUniqueOrder = uniqueOrderSize.filter(
                (a) =>
                  order.customercode === a.customercode && order.pono === a.pono
              );
            } else if (customerDetails) {
              filteredUniqueOrder = uniqueOrderSize.filter(
                (a) => order.customercode === a.customercode
              );
            }

            let totalSheet = 0;
            let remarks = [];
            for (
              let uniqueIndex = 0;
              uniqueIndex < filteredUniqueOrder.length;
              uniqueIndex++
            ) {
              const uniqueOrderData = filteredUniqueOrder[uniqueIndex];
              if (uniqueOrderData.remarks) {
                remarks.push(uniqueOrderData.remarks);
              }
              for (
                let partionIndex = 0;
                partionIndex < acceptedSolution.solution.partitions.length;
                partionIndex++
              ) {
                const partitions =
                  acceptedSolution.solution.partitions[partionIndex];
                let filteredPartition = partitions.partition.filter(
                  (partition) => partition.order_id == uniqueOrderData.orderno
                );
                totalSheet =
                  totalSheet + filteredPartition.length * partitions.repeated;
              }
            }
            let WeightSum = 0;
            let uniquePO = filteredUniqueOrder.filter(
              (a, i) =>
                filteredUniqueOrder.findIndex((s) => a.pono === s.pono) === i
            );
            let po = "";

            uniquePO.map((item, index) => {
              po = po + item.pono + (index < uniquePO.length - 1 ? ", " : "");
            });

            filteredUniqueOrder.map((item) => {
              WeightSum += Number(item.fWeight);
            });
            let orderData = {
              totalSheet: totalSheet,
              customername: filteredUniqueOrder[0].customername,
              consignee_name: filteredUniqueOrder[0].consignee_name,
              group:
                filteredUniqueOrder[0].grain.toLowerCase() === "short"
                  ? "SG"
                  : "LG",
              length: filteredUniqueOrder[0].length,
              width: filteredUniqueOrder[0].width,
              units: filteredUniqueOrder[0].units,
              size: filteredUniqueOrder[0].size,
              productInfo: filteredUniqueOrder[0].productInfo,
              no_of_sheets: filteredUniqueOrder[0].no_of_sheets,
              fulfilledWeight: WeightSum.toFixed(3),
              pono: filteredUniqueOrder[0].pono,
              type: filteredUniqueOrder[0].type,
              fWeightUnit: filteredUniqueOrder[0].fWeightUnit,
              remarks: remarks,
            };
            orders.push(orderData);
          }
        }
        setCustomerWiseOrder(orders);
      } else if (consigneeDetails) {
        let uniqueSize = orderDetailsList.filter(
          (a, i) =>
            orderDetailsList.findIndex(
              (s) =>
                a.width === s.width &&
                a.length === s.length &&
                a.grain === s.grain
            ) === i
        );
        let orders = [];
        for (let sizeIndex = 0; sizeIndex < uniqueSize.length; sizeIndex++) {
          const size = uniqueSize[sizeIndex];
          let uniqueOrderSize = orderDetailsList.filter(
            (a) =>
              a.width === size.width &&
              a.length === size.length &&
              a.grain === size.grain
          );
          if (poDetails) {
            filteredOrder = uniqueOrderSize.filter(
              (a, i) =>
                uniqueOrderSize.findIndex(
                  (s) =>
                    a.consignee_code === s.consignee_code && a.pono === s.pono
                ) === i
            );
          } else {
            filteredOrder = uniqueOrderSize.filter(
              (a, i) =>
                uniqueOrderSize.findIndex(
                  (s) => a.consignee_code === s.consignee_code
                ) === i
            );
          }

          for (
            let orderIndex = 0;
            orderIndex < filteredOrder.length;
            orderIndex++
          ) {
            const order = filteredOrder[orderIndex];
            let filteredUniqueOrder = [];
            if (poDetails) {
              filteredUniqueOrder = uniqueOrderSize.filter(
                (a) =>
                  order.consignee_code === a.consignee_code &&
                  order.pono === a.pono
              );
            } else {
              filteredUniqueOrder = uniqueOrderSize.filter(
                (a) => order.consignee_code === a.consignee_code
              );
            }
            let totalSheet = 0;
            let remarks = [];
            for (
              let uniqueIndex = 0;
              uniqueIndex < filteredUniqueOrder.length;
              uniqueIndex++
            ) {
              const uniqueOrderData = filteredUniqueOrder[uniqueIndex];
              if (uniqueOrderData.remarks) {
                remarks.push(uniqueOrderData.remarks);
              }
              for (
                let partionIndex = 0;
                partionIndex < acceptedSolution.solution.partitions.length;
                partionIndex++
              ) {
                const partitions =
                  acceptedSolution.solution.partitions[partionIndex];
                let filteredPartition = partitions.partition.filter(
                  (partition) => partition.order_id == uniqueOrderData.orderno
                );
                totalSheet =
                  totalSheet + filteredPartition.length * partitions.repeated;
              }
            }
            let WeightSum = 0;
            let uniquePO = filteredUniqueOrder.filter(
              (a, i) =>
                filteredUniqueOrder.findIndex((s) => a.pono === s.pono) === i
            );
            let po = "";

            uniquePO.map((item, index) => {
              po = po + item.pono + (index < uniquePO.length - 1 ? ", " : "");
            });

            filteredUniqueOrder.map((item) => {
              WeightSum += Number(item.fWeight);
            });
            let orderData = {
              totalSheet: totalSheet,
              customername: filteredUniqueOrder[0].customername,
              consignee_name: filteredUniqueOrder[0].consignee_name,
              group:
                filteredUniqueOrder[0].grain.toLowerCase() === "short"
                  ? "SG"
                  : "LG",
              length: filteredUniqueOrder[0].length,
              width: filteredUniqueOrder[0].width,
              units: filteredUniqueOrder[0].units,
              size: filteredUniqueOrder[0].size,
              productInfo: filteredUniqueOrder[0].productInfo,
              no_of_sheets: filteredUniqueOrder[0].no_of_sheets,
              fulfilledWeight: WeightSum.toFixed(3),
              pono: filteredUniqueOrder[0].pono,
              type: filteredUniqueOrder[0].type,
              fWeightUnit: filteredUniqueOrder[0].fWeightUnit,
              remarks: remarks,
            };
            orders.push(orderData);
          }
        }
        setConsigneeWiseOrder(orders);
      } else if (poDetails) {
        let uniqueSize = orderDetailsList.filter(
          (a, i) =>
            orderDetailsList.findIndex(
              (s) =>
                a.width === s.width &&
                a.length === s.length &&
                a.grain === s.grain
            ) === i
        );
        let orders = [];
        for (let sizeIndex = 0; sizeIndex < uniqueSize.length; sizeIndex++) {
          const size = uniqueSize[sizeIndex];
          let uniqueOrderSize = orderDetailsList.filter(
            (a) =>
              a.width === size.width &&
              a.length === size.length &&
              a.grain === size.grain
          );

          filteredOrder = uniqueOrderSize.filter(
            (a, i) => uniqueOrderSize.findIndex((s) => a.pono === s.pono) === i
          );

          for (
            let orderIndex = 0;
            orderIndex < filteredOrder.length;
            orderIndex++
          ) {
            const order = filteredOrder[orderIndex];
            let filteredUniqueOrder = [];

            filteredUniqueOrder = uniqueOrderSize.filter(
              (a) => order.pono === a.pono
            );

            let totalSheet = 0;
            let remarks = [];
            for (
              let uniqueIndex = 0;
              uniqueIndex < filteredUniqueOrder.length;
              uniqueIndex++
            ) {
              const uniqueOrderData = filteredUniqueOrder[uniqueIndex];
              if (uniqueOrderData.remarks) {
                remarks.push(uniqueOrderData.remarks);
              }
              for (
                let partionIndex = 0;
                partionIndex < acceptedSolution.solution.partitions.length;
                partionIndex++
              ) {
                const partitions =
                  acceptedSolution.solution.partitions[partionIndex];
                let filteredPartition = partitions.partition.filter(
                  (partition) => partition.order_id == uniqueOrderData.orderno
                );
                totalSheet =
                  totalSheet + filteredPartition.length * partitions.repeated;
              }
            }
            let WeightSum = 0;
            let uniquePO = filteredUniqueOrder.filter(
              (a, i) =>
                filteredUniqueOrder.findIndex((s) => a.pono === s.pono) === i
            );
            let po = "";

            uniquePO.map((item, index) => {
              po = po + item.pono + (index < uniquePO.length - 1 ? ", " : "");
            });

            filteredUniqueOrder.map((item) => {
              WeightSum += Number(item.fWeight);
            });
            let orderData = {
              totalSheet: totalSheet,
              customername: filteredUniqueOrder[0].customername,
              consignee_name: filteredUniqueOrder[0].consignee_name,
              group:
                filteredUniqueOrder[0].grain.toLowerCase() === "short"
                  ? "SG"
                  : "LG",
              length: filteredUniqueOrder[0].length,
              width: filteredUniqueOrder[0].width,
              units: filteredUniqueOrder[0].units,
              size: filteredUniqueOrder[0].size,
              productInfo: filteredUniqueOrder[0].productInfo,
              no_of_sheets: filteredUniqueOrder[0].no_of_sheets,
              fulfilledWeight: WeightSum.toFixed(3),
              pono: filteredUniqueOrder[0].pono,
              type: filteredUniqueOrder[0].type,
              fWeightUnit: filteredUniqueOrder[0].fWeightUnit,
              remarks: remarks,
            };
            orders.push(orderData);
          }
        }
        setPoWiseOrder(orders);
      } else {
        let uniqueSize = orderDetailsList.filter(
          (a, i) =>
            orderDetailsList.findIndex(
              (s) =>
                a.width === s.width &&
                a.length === s.length &&
                a.grain === s.grain
            ) === i
        );
        let orders = [];
        for (let sizeIndex = 0; sizeIndex < uniqueSize.length; sizeIndex++) {
          const size = uniqueSize[sizeIndex];
          let filteredOrder = orderDetailsList.filter(
            (a) =>
              a.width === size.width &&
              a.length === size.length &&
              a.grain === size.grain
          );

          let totalSheet = 0;
          let remarks = [];
          for (
            let uniqueIndex = 0;
            uniqueIndex < filteredOrder.length;
            uniqueIndex++
          ) {
            const uniqueOrderData = filteredOrder[uniqueIndex];
            if (uniqueOrderData.remarks) {
              remarks.push(uniqueOrderData.remarks);
            }
            for (
              let partionIndex = 0;
              partionIndex < acceptedSolution.solution.partitions.length;
              partionIndex++
            ) {
              const partitions =
                acceptedSolution.solution.partitions[partionIndex];
              let filteredPartition = partitions.partition.filter(
                (partition) => partition.order_id == uniqueOrderData.orderno
              );
              totalSheet =
                totalSheet + filteredPartition.length * partitions.repeated;
            }
          }
          let WeightSum = 0;
          let uniquePO = filteredOrder.filter(
            (a, i) => filteredOrder.findIndex((s) => a.pono === s.pono) === i
          );
          let po = "";

          uniquePO.map((item, index) => {
            po = po + item.pono + (index < uniquePO.length - 1 ? ", " : "");
          });

          filteredOrder.map((item) => {
            WeightSum += Number(item.fWeight);
          });
          let orderData = {
            totalSheet: totalSheet,
            customername: filteredOrder[0].customername,
            consignee_name: filteredOrder[0].consignee_name,
            group:
              filteredOrder[0].grain.toLowerCase() === "short" ? "SG" : "LG",
            length: filteredOrder[0].length,
            width: filteredOrder[0].width,
            units: filteredOrder[0].units,
            size: filteredOrder[0].size,
            productInfo: filteredOrder[0].productInfo,
            no_of_sheets: filteredOrder[0].no_of_sheets,
            fulfilledWeight: WeightSum.toFixed(3),
            pono: filteredOrder[0].pono,
            type: filteredOrder[0].type,
            fWeightUnit: filteredOrder[0].fWeightUnit,
            remarks: remarks,
          };
          orders.push(orderData);
        }
        setSheetOrder(orders);
      }

      await getUnitData()
        .then((response) => {
          setUnitData(response.data);
        })
        .catch((error) => {
          console.log(error);
        });
    })();
  }, [customerDetails, consigneeDetails, productDetails, poDetails]);

  useEffect(async () => {
    if (jobId) {
      orderDetails.current = [];
      customerWiseOrderDetails.current = [];
      sizeWiseOrderDetails.current = [];
      await getJobCardsById(jobId)
        .then((response) => {
          setJobCardSummary(response.jobcard);
        })
        .catch((error) => {
          console.log(error);
        });

      await getDeckleFormats()
        .then((resp) => {
          setFormatData(resp?.formats);
        })
        .catch((error) => {
          console.log(error);
        });
    }
    return () => { };
  }, [jobId]);

  useEffect(() => {
    if (formatData.length) {
      setFormatTab([
        { label: "Format1", value: "format_1" },
        { label: "Format2", value: "format_2" },
        { label: "Format3", value: "format_3" },
      ]);
      let formatArr = formatData.filter((format) => format.value);
      setSelectedFormat(formatArr[0].name);

      if (formatArr[0].name == "format_1") {
        setNetTrim(formatArr[0].keys.net_trim);
        setEdgeTrim(formatArr[0].keys.edge_trim);
        setDeliveryDate(formatArr[0].keys.delivery_date);
        setOrderRemarks(formatArr[0].keys.order_remarks);
        setProductDetails(formatArr[0].keys.product_details);
        setCustomerDetails(formatArr[0].keys.customer_details);
        setConsigneeDetails(formatArr[0].keys.consignee_details);
        setPoDetails(formatArr[0].keys.po_details);
      }

      // setCheckBoxValue(formatArr[0].value);
    }
  }, [formatData]);

  useEffect(() => {
    if (!company) setCompanyDetails();
  }, [company]);

  useEffect(()=>{
    (async()=>
    {
      try{
        if(props?.print){
          await printButtonClick();
          props?.setPrint(false);
        }
      }
      catch(e)
      {
        console.log(e);
      }
    })();
  },[props?.print])

  return (
    <RightLayoutContainer>
      <style>{getPageMargins()}</style>
      {props?.module != "deckle"?<PageTitleComp className="marginRightAdg">
        <PageHeader
          ghost={false}
          onBack={() => window.history.back()}
          title="Job Card Preview"
          extra={[
            <Button
              disabled={!dataSet || !unitData}
              key="1"
              className="themeBtn"
              onClick={printButtonClick}
            >
              <Iconmoon icon="printer" size={16} color="#FFFFFF" />
              Print Job Card
            </Button>,
          ]}
        ></PageHeader>
      </PageTitleComp>:<></>}

      {/* side panel */}
      {formatData && (
        <Layout style={{ backgroundColor: "#ffffff", paddingTop: "11px" }}>
          <Row span={24}>
            <Col span={8}>
              <PaperMachineRecordsData>
                <div className="printSidePanel">
                  <div
                    style={{
                      color: "var(--black-color)",
                      fontSize: "20px",
                      lineHeight: "28px",
                      fontFamily: "var(--sf-pro-display-m)",
                      fontWeight: "500",
                      margin: "0px",
                    }}
                  >
                    <span>Select Format</span>
                    <p
                      style={{
                        fontSize: "12px",
                        lineHeight: "20px",
                        fontFamily: "var(--sf-pro-text)",
                        color: "var(--para-text)",
                        marginTop: "2px",
                      }}
                    >
                      Here you can select the format to be used for printing job
                      card
                    </p>
                  </div>
                  <div
                    className="switchRadio twoSwitch"
                    style={{ justifyContent: "center", display: "flex" }}
                  >
                    <Radio.Group
                      options={formatTab}
                      optionType="button"
                      buttonStyle="solid"
                      value={selectedFormat}
                      onChange={handleFormatChange}
                      disabled={!dataSet || !unitData}
                    />
                  </div>
                  {selectedFormat === "format_1" || selectedFormat === "format_3" ? (
                    <div>
                      <div
                        style={{
                          marginTop: "10px",
                          marginBottom: "10px",
                          borderBottom: "1px solid grey",
                        }}
                      />

                      <PaperMachineScroll
                        style={{
                          padding: "5%",
                          height: "270px",
                          marginLeft: "-11px",
                        }}
                      >
                        <div
                          style={{
                            color: "var(--black-color)",
                            fontSize: "20px",
                            lineHeight: "28px",
                            fontFamily: "var(--sf-pro-display-m)",
                            fontWeight: "500",
                            marginTop: "-10px",
                          }}
                        >
                          <span>Select Options</span>
                          <p
                            style={{
                              fontSize: "12px",
                              lineHeight: "20px",
                              fontFamily: "var(--sf-pro-text)",
                              color: "var(--para-text)",
                              marginTop: "2px",
                            }}
                          >
                            Here you can select the details that should be
                            included in the job card print format.
                          </p>
                        </div>
                        <div className="groupDetailWrap">
                          <Row
                            gutter={[16, 16]}
                            className="groupForm"
                            style={{ rowGap: "0px" }}
                          >
                            <Col span={16}>
                              <Row className="centerAlign">
                                <Col span={16}>
                                  <div className="boxFieldTitle">
                                    <label>Edge Trim</label>
                                  </div>
                                </Col>
                                <Col span={8}>
                                  <div
                                    className="boxFormType"
                                    style={{ marginLeft: "100px" }}
                                  >
                                    <GlobalSet>
                                      <Styled>
                                        <Switch
                                          checked={edgeTrim}
                                          onChange={edgeTrimHandler}
                                          className="switch-new"
                                          disabled={!dataSet || !unitData}
                                        />
                                      </Styled>
                                    </GlobalSet>
                                  </div>
                                </Col>
                              </Row>
                            </Col>
                            <Col span={16}>
                              <Row className="centerAlign">
                                <Col span={16}>
                                  <div className="boxFieldTitle">
                                    <label>Net Trim</label>
                                  </div>
                                </Col>
                                <Col span={8}>
                                  <div
                                    className="boxFormType"
                                    style={{ marginLeft: "100px" }}
                                  >
                                    <GlobalSet>
                                      <Styled>
                                        <Switch
                                          checked={netTrim}
                                          onChange={netTrimHandler}
                                          className="switch-new"
                                          disabled={!dataSet || !unitData}
                                        />
                                      </Styled>
                                    </GlobalSet>
                                  </div>
                                </Col>
                              </Row>
                            </Col>
                            {selectedFormat === "format_1" && (
                              <Col span={16}>
                                <Row className="centerAlign">
                                  <Col span={16}>
                                    <div className="boxFieldTitle">
                                      <label>Delivery Date</label>
                                    </div>
                                  </Col>
                                  <Col span={8}>
                                    <div
                                      className="boxFormType"
                                      style={{ marginLeft: "100px" }}
                                    >
                                      <GlobalSet>
                                        <Styled>
                                          <Switch
                                            checked={deliveryDate}
                                            onChange={deliveryDateHandler}
                                            className="switch-new"
                                            disabled={!dataSet || !unitData}
                                          />
                                        </Styled>
                                      </GlobalSet>
                                    </div>
                                  </Col>
                                </Row>
                              </Col>
                            )}

                            <Col span={16}>
                              <Row className="centerAlign">
                                <Col span={16}>
                                  <div className="boxFieldTitle">
                                    <label>Customer Details</label>
                                  </div>
                                </Col>
                                <Col span={8}>
                                  <div
                                    className="boxFormType"
                                    style={{ marginLeft: "100px" }}
                                  >
                                    <GlobalSet>
                                      <Styled>
                                        <Switch
                                          checked={customerDetails}
                                          onChange={customerDetailsHandler}
                                          className="switch-new"
                                          disabled={!dataSet || !unitData}
                                        />
                                      </Styled>
                                    </GlobalSet>
                                  </div>
                                </Col>
                              </Row>
                            </Col>
                            <Col span={16}>
                              <Row className="centerAlign">
                                <Col span={16}>
                                  <div className="boxFieldTitle">
                                    <label>Consignee Details</label>
                                  </div>
                                </Col>
                                <Col span={8}>
                                  <div
                                    className="boxFormType"
                                    style={{ marginLeft: "100px" }}
                                  >
                                    <GlobalSet>
                                      <Styled>
                                        <Switch
                                          checked={consigneeDetails}
                                          onChange={consingeeDetailsHandler}
                                          className="switch-new"
                                          disabled={!dataSet || !unitData}
                                        />
                                      </Styled>
                                    </GlobalSet>
                                  </div>
                                </Col>
                              </Row>
                            </Col>
                            <Col span={16}>
                              <Row className="centerAlign">
                                <Col span={16}>
                                  <div className="boxFieldTitle">
                                    <label>PO Details</label>
                                  </div>
                                </Col>
                                <Col span={8}>
                                  <div
                                    className="boxFormType"
                                    style={{ marginLeft: "100px" }}
                                  >
                                    <GlobalSet>
                                      <Styled>
                                        <Switch
                                          checked={poDetails}
                                          onChange={poDetailsHandler}
                                          className="switch-new"
                                          disabled={!dataSet || !unitData}
                                        />
                                      </Styled>
                                    </GlobalSet>
                                  </div>
                                </Col>
                              </Row>
                            </Col>
                            <Col span={16}>
                              <Row className="centerAlign">
                                <Col span={16}>
                                  <div className="boxFieldTitle">
                                    <label>Product Details</label>
                                  </div>
                                </Col>
                                <Col span={8}>
                                  <div
                                    className="boxFormType"
                                    style={{ marginLeft: "100px" }}
                                  >
                                    <GlobalSet>
                                      <Styled>
                                        <Switch
                                          checked={productDetails}
                                          onChange={productDetailsHandler}
                                          className="switch-new"
                                          disabled={!dataSet || !unitData}
                                        />
                                      </Styled>
                                    </GlobalSet>
                                  </div>
                                </Col>
                              </Row>
                            </Col>
                            <Col span={16}>
                              <Row className="centerAlign">
                                <Col span={16}>
                                  <div className="boxFieldTitle">
                                    <label>Order Remarks</label>
                                  </div>
                                </Col>
                                <Col span={8}>
                                  <div
                                    className="boxFormType"
                                    style={{ marginLeft: "100px" }}
                                  >
                                    <GlobalSet>
                                      <Styled>
                                        <Switch
                                          checked={orderRemarks}
                                          onChange={orderRemarksHandler}
                                          className="switch-new"
                                          disabled={!dataSet || !unitData}
                                        />
                                      </Styled>
                                    </GlobalSet>
                                  </div>
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                        </div>
                      </PaperMachineScroll>
                    </div>
                  ) : (
                    <div style={{ minHeight: "290px" }} />
                  )}
                  <div
                    style={{
                      marginTop: "10px",
                      marginBottom: "10px",
                      borderBottom: "1px solid grey",
                    }}
                  />
                  <Row className="centerAlign justifyCSBetween">
                    <Checkbox
                      className="printCheckBoxStyle"
                      type="checkbox"
                      value={checkboxValue}
                      checked={checkboxValue}
                      onChange={saveFormatCheckbox}
                    ></Checkbox>
                    <label style={{ marginRight: "78px", marginTop: "-2px" }}>
                      Save selection as default selection
                    </label>
                  </Row>
                </div>
              </PaperMachineRecordsData>
            </Col>
            {dataSet && unitData ? (
              <Col span={16}>
                <PrintData id="export-content">
                  <OtherPages>
                    <Layout
                      style={{
                        backgroundColor: "#ffffff",
                        marginTop: "-40px",
                        paddingRight: "17%",
                        width: "100%",
                      }}
                    >
                      <div ref={printRef}>
                        <ExportHeader>
                          <div className="file-header">
                            <div
                              className="file-header-logo"
                              style={{ display: "block" }}
                            >
                              <img src={logoCompany} alt="Kaiznn" />
                              {company && (
                                <div>
                                  {" "}
                                  <h4
                                    style={{
                                      width: "max-content",
                                      fontWeight: "bold",
                                      fontSize: "15px",
                                    }}
                                  >
                                    {company.business_name}
                                  </h4>
                                </div>
                              )}
                            </div>
                            <div
                              className="client-name"
                              style={{ width: "55%" }}
                            >
                              <div className="client-data">
                                <div>
                                  <h5
                                    style={{
                                      // width: "max-content",
                                      width: "200%",
                                      wordBreak: "break-all",
                                      fontWeight: "bold",
                                      fontSize: "15px",
                                    }}
                                  >
                                    Job Card:{" "}
                                    {jobCardCode +
                                      " ( " +
                                      jobCard.group.machines[0].name +
                                      "-" +
                                      jobCard.group.machines[0].cutter_name +
                                      " )"}
                                  </h5>
                                </div>
                              </div>
                              <div className="client-data">
                                <div>
                                  <div
                                    style={{
                                      marginRight: "2px",
                                      fontWeight: "bold",
                                      fontSize: "15px",
                                    }}
                                  >
                                    <label
                                      style={{
                                        fontWeight: "bold",
                                        fontSize: "15px",
                                      }}
                                    >
                                      Total Number of Sets:
                                    </label>
                                  </div>
                                  <br />
                                  <div
                                    style={{
                                      marginRight: "2px",
                                      marginTop: "-20px",
                                      fontSize: "10px",
                                    }}
                                  >
                                    <span
                                      style={{
                                        fontWeight: "bold",
                                        fontSize: "15px",
                                      }}
                                    >
                                      {
                                        acceptedSolution.solution.summary
                                          .total_patterns
                                      }
                                    </span>
                                  </div>
                                </div>
                                <div>
                                  <div
                                    style={{
                                      marginRight: "2px",
                                      fontWeight: "bold",
                                      fontSize: "15px",
                                    }}
                                  >
                                    <label
                                      style={{
                                        fontWeight: "bold",
                                        fontSize: "15px",
                                      }}
                                    >
                                      Date:
                                    </label>
                                  </div>
                                  <br />
                                  <div
                                    style={{
                                      marginRight: "2px",
                                      marginTop: "-20px",
                                      fontSize: "10px",
                                    }}
                                  >
                                    <span
                                      style={{
                                        fontWeight: "bold",
                                        fontSize: "15px",
                                      }}
                                    >
                                      {moment(today).format("DD MMMM, YYYY")}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </ExportHeader>
                        {selectedFormat === "format_1" && dataSet && (
                          <div>
                            <ExportAdditional>
                              <div className="export-additional">
                                <div
                                  className="additional-col-format-1"
                                  style={{ width: "60px" }}
                                >
                                  <p
                                    style={{
                                      fontWeight: "bold",
                                      fontSize: "15px",
                                      marginBottom: "0em",
                                      wordWrap: "break-word",
                                    }}
                                  >
                                    Grade: {jobCard.group.grouping_params.grade}
                                  </p>
                                  <p
                                    style={{
                                      marginBottom: "0em",
                                      fontSize: "15px",
                                    }}
                                  >
                                    Weight:{" "}
                                    {acceptedSolution.solution?.summary?.job_card_weight?.toFixed(
                                      2
                                    )}{" "}
                                    {acceptedSolution.solution?.summary?.units
                                      ?.job_card_weight
                                      ? capitalize(
                                        weightUnit[
                                          acceptedSolution.solution?.summary
                                            ?.units?.job_card_weight
                                        ].displayName
                                      )
                                      : "T"}{" "}
                                  </p>
                                  <p
                                    style={{
                                      marginBottom: "0em",
                                      fontSize: "15px",
                                    }}
                                  >
                                    GSM:{jobCard.group.grouping_params.gsm}{" "}
                                  </p>
                                </div>
                                <div className="additional-col-format-1">
                                  <p
                                    style={{
                                      fontWeight: "bold",
                                      fontSize: "15px",
                                      marginBottom: "0em",
                                      wordWrap: "break-word",
                                    }}
                                  >
                                    Quality:{" "}
                                    {jobCard.group.grouping_params.quality}
                                  </p>
                                  <p
                                    style={{
                                      marginBottom: "0em",
                                      fontSize: "15px",
                                    }}
                                  >
                                    Unique Set:{" "}
                                    {
                                      acceptedSolution.solution.summary
                                        .total_unique_patterns
                                    }
                                  </p>
                                  {jobCard.group.grouping_params.moisture ? (
                                    <p
                                      style={{
                                        marginBottom: "0em",
                                        fontSize: "15px",
                                      }}
                                    >
                                      Moisture:
                                      {jobCard.group.grouping_params.moisture}
                                    </p>
                                  ) : null}
                                </div>
                                <div className="additional-col-format-1">
                                  <p
                                    style={{
                                      fontWeight: "bold",
                                      fontSize: "15px",
                                      marginBottom: "0em",
                                    }}
                                  >
                                    Trim Loss:{" "}
                                    {acceptedSolution.solution.summary.match_trimloss_percent_width.toFixed(
                                      3
                                    )}{" "}
                                    %
                                  </p>
                                  <p
                                    style={{
                                      marginBottom: "0em",
                                      fontSize: "15px",
                                    }}
                                  >
                                    Sheet:{" "}
                                    {acceptedSolution.solution.summary
                                      .fulfillment_priority_fulfillment_quantity +
                                      acceptedSolution.solution.summary
                                        .fulfillment_standard_fulfillment_quantity +
                                      acceptedSolution.solution.summary
                                        .fulfillment_optional_fulfillment_quantity +
                                      acceptedSolution.solution.summary
                                        .fulfillment_stock_fulfillment_quantity}
                                  </p>
                                </div>
                                <div className="additional-col-format-1">
                                  <p
                                    style={{
                                      fontWeight: "bold",
                                      fontSize: "15px",
                                      marginBottom: "0em",
                                    }}
                                  >
                                    Fulfillment:{" "}
                                    {acceptedSolution.solution.summary.total_fulfillment_percent.toFixed(
                                      3
                                    )}
                                    %
                                  </p>
                                  <p
                                    style={{
                                      marginBottom: "0em",
                                      fontSize: "15px",
                                    }}
                                  >
                                    Priority Sheet:{" "}
                                    {
                                      acceptedSolution.solution.summary
                                        .fulfillment_priority_fulfillment_quantity
                                    }
                                  </p>
                                </div>
                              </div>
                            </ExportAdditional>
                            {jobCardSummary.group && msgVisible && (
                              <ExportNote>
                                <div className="export-additional">
                                  <p
                                    style={{
                                      marginBottom: "0em",
                                      fontSize: "13px",
                                    }}
                                  >
                                    Note: Multiple groups were merged while creating this job card.
                                  </p>
                                </div>
                              </ExportNote>
                            )}
                            <ExportTableForm1>
                              {/* {jobCardDetails.map((item) => ( */}
                              <div style={{ marginBottom: "10px" }}>
                                <label
                                  style={{
                                    fontStyle: "italic",
                                    fontSize: "smaller",
                                    paddingLeft: "72%",
                                  }}
                                >
                                  *Sizes in coloured cells are priority sizes
                                </label>
                                <table>
                                  <thead>
                                    <tr>
                                      {edgeTrim && (
                                        <th style={{ fontSize: "12px" }}>
                                          EDGE TRIM (L)
                                        </th>
                                      )}
                                      {/* {item.orderWidthArray.map((order, index) => (
                                      <th>{index + 1}</th>))}*/}
                                      {orderWidthArr.map((order, index) => (
                                        <th style={{ fontSize: "12px" }}>
                                          {index + 1}
                                        </th>
                                      ))}
                                      <th style={{ fontSize: "12px" }}>
                                        D.COM. WIDTH
                                      </th>
                                      <th style={{ fontSize: "12px" }}>CHOP</th>
                                      <th style={{ fontSize: "12px" }}>TRIM</th>
                                      {edgeTrim && (
                                        <th style={{ fontSize: "12px" }}>
                                          EDGE TRIM (R)
                                        </th>
                                      )}
                                      {netTrim && (
                                        <th style={{ fontSize: "12px" }}>
                                          NET TRIM
                                        </th>
                                      )}
                                      <th style={{ fontSize: "12px" }}>
                                        Quantity
                                      </th>
                                      <th style={{ fontSize: "12px" }}>
                                        Sets Weight
                                      </th>
                                      {deliveryDate && (
                                        <th style={{ fontSize: "12px" }}>
                                          Earliest DEL. DATE
                                        </th>
                                      )}
                                    </tr>
                                  </thead>
                                  {dataSet.map((item) => (
                                    <tbody>
                                      <tr>
                                        {edgeTrim && (
                                          <td>
                                            <p
                                              style={{
                                                fontWeight: "bold",
                                                fontSize: "12px !important",
                                                color: "#605e5c",
                                                fontStyle: "italic",
                                              }}
                                            >
                                              {item.leftTrim}{" "}
                                              {jobCard.group.machines[0].units
                                                ?.left_edge_trim
                                                ? lengthUnit[
                                                  jobCard.group.machines[0]
                                                    .units?.left_edge_trim
                                                ].displayName.toUpperCase()
                                                : "CM"}
                                            </p>
                                          </td>
                                        )}
                                        {orderWidthArr.map((order, index) => (
                                          <td
                                            className={
                                              item?.widthData[index]
                                                ?.priority &&
                                                item?.widthData[index]?.type ===
                                                "order"
                                                ? "priority"
                                                : ""
                                            }
                                          >
                                            <p
                                              style={{
                                                fontWeight: "bold",
                                                fontSize: "12px !important",
                                                color: "#605e5c",
                                                fontStyle: "italic",
                                              }}
                                            >
                                              {(item?.widthData[index]?.width
                                                ? item?.widthData[index]?.width
                                                : "") +
                                                (item?.widthData[index]
                                                  ?.priority
                                                  ? "*"
                                                  : "")}
                                            </p>
                                          </td>
                                        ))}
                                        <td>
                                          <p
                                            style={{
                                              fontWeight: "bold",
                                              fontSize: "12px !important",
                                              color: "#605e5c",
                                              fontStyle: "italic",
                                            }}
                                          >
                                            {item.totalWidth}{" "}
                                            {item.units?.breadth
                                              ? lengthUnit[
                                                item.units.breadth
                                              ].displayName.toUpperCase()
                                              : "CM"}
                                          </p>
                                        </td>
                                        <td>
                                          <p
                                            style={{
                                              fontWeight: "bold",
                                              fontSize: "12px !important",
                                              color: "#605e5c",
                                              fontStyle: "italic",
                                            }}
                                          >
                                            {item.chop}{" "}
                                            {item.units?.length
                                              ? lengthUnit[
                                                item.units.length
                                              ].displayName.toUpperCase()
                                              : "CM"}
                                          </p>
                                        </td>
                                        <td>
                                          <p
                                            style={{
                                              fontWeight: "bold",
                                              fontSize: "12px !important",
                                              color: "#605e5c",
                                              fontStyle: "italic",
                                            }}
                                          >
                                            {item.trim}{" "}
                                            {item.units?.trim_loss_width
                                              ? lengthUnit[
                                                item.units.trim_loss_width
                                              ].displayName.toUpperCase()
                                              : "CM"}
                                          </p>
                                        </td>
                                        {edgeTrim && (
                                          <td>
                                            <p
                                              style={{
                                                fontWeight: "bold",
                                                fontSize: "12px !important",
                                                color: "#605e5c",
                                                fontStyle: "italic",
                                              }}
                                            >
                                              {item.rightTrim}{" "}
                                              {jobCard.group.machines[0].units
                                                ?.right_edge_trim
                                                ? lengthUnit[
                                                  jobCard.group.machines[0]
                                                    .units?.right_edge_trim
                                                ].displayName.toUpperCase()
                                                : "CM"}
                                            </p>
                                          </td>
                                        )}
                                        {netTrim && (
                                          <td>
                                            <p
                                              style={{
                                                fontWeight: "bold",
                                                fontSize: "12px !important",
                                                color: "#605e5c",
                                                fontStyle: "italic",
                                              }}
                                            >
                                              {(
                                                item.leftTrim +
                                                item.trim +
                                                item.rightTrim
                                              ).toFixed(3)}{" "}
                                              {jobCard.group.machines[0].units
                                                ?.right_edge_trim
                                                ? lengthUnit[
                                                  jobCard.group.machines[0]
                                                    .units?.right_edge_trim
                                                ].displayName.toUpperCase()
                                                : "CM"}
                                            </p>
                                          </td>
                                        )}
                                        <td>
                                          <p
                                            style={{
                                              fontWeight: "bold",
                                              fontSize: "12px !important",
                                              color: "#605e5c",
                                              fontStyle: "italic",
                                            }}
                                          >
                                            {item.quantity}
                                          </p>
                                        </td>
                                        <td>
                                          <p
                                            style={{
                                              fontWeight: "bold",
                                              fontSize: "12px !important",
                                              color: "#605e5c",
                                              fontStyle: "italic",
                                            }}
                                          >
                                            {item.weight}{" "}
                                            {item.units?.weight
                                              ? capitalize(
                                                weightUnit[item.units.weight]
                                                  .displayName
                                              )
                                              : "T"}
                                          </p>
                                        </td>
                                        {deliveryDate && (
                                          <td>
                                            <p
                                              style={{
                                                fontWeight: "bold",
                                                fontSize: "12px !important",
                                                color: "#605e5c",
                                                fontStyle: "italic",
                                              }}
                                            >
                                              {item.deldate}
                                            </p>
                                          </td>
                                        )}
                                      </tr>
                                    </tbody>
                                  ))}
                                </table>

                                {productDetails ? (
                                  productWiseOrder.map((products) => (
                                    <table
                                      style={{
                                        border: "none",
                                        marginBottom: "10px",
                                      }}
                                    >
                                      {productDetails && (
                                        <tr style={{ border: "none" }}>
                                          <td
                                            rowSpan={
                                              products.orders.length / 2 + 2
                                            }
                                            style={{
                                              borderBottom: "0px",
                                              borderTop: "0px",
                                              width: "29%",
                                            }}
                                          >
                                            <div
                                              style={{
                                                border: "1px solid gray",
                                                borderRadius: "5px",
                                                padding: "10px 0px",
                                              }}
                                            >
                                              <div
                                                className="reelForFormat2"
                                                style={{
                                                  marginLeft: "5px",
                                                  display: "flex",
                                                  flexDirection: "row",
                                                  fontSize: "13px",
                                                  fontWeight: "bold",
                                                }}
                                              >
                                                <div>GSM: {products.gsm}</div>
                                                {products?.burst_factor && (
                                                  <div
                                                    style={{
                                                      marginLeft: "10px",
                                                    }}
                                                  >
                                                    BF:{products?.burst_factor}
                                                  </div>
                                                )}
                                                {products.moisture ? (
                                                  <div
                                                    style={{
                                                      marginLeft: "10px",
                                                    }}
                                                  >
                                                    Moisture:{" "}
                                                    {products.moisture}
                                                  </div>
                                                ) : (
                                                  ""
                                                )}
                                              </div>
                                              <div
                                                className="reelForFormat2"
                                                style={{
                                                  textAlign: "left",
                                                  marginLeft: "5px",
                                                  display: "flex",
                                                  flexDirection: "column",
                                                  fontSize: "13px",
                                                  fontWeight: "bold",
                                                }}
                                              >
                                                <div>
                                                  Quality: {products.quality}
                                                </div>
                                                <div>
                                                  Grade: {products.grade}
                                                </div>
                                              </div>
                                            </div>
                                          </td>
                                        </tr>
                                      )}
                                      <tr style={{ border: "none" }}>
                                        <td
                                          style={{
                                            border: "none",
                                            verticalAlign: "top",
                                          }}
                                        >
                                          <table style={{ border: "none" }}>
                                            {products.orders.map(
                                              (item, index) => (
                                                <div>
                                                  {index % 2 == 0 && (
                                                    <tr
                                                      style={{ border: "none" }}
                                                    >
                                                      <td
                                                        style={{
                                                          border: "none",
                                                          textAlign: "left",
                                                        }}
                                                      >
                                                        {item && (
                                                          <div
                                                            style={{
                                                              display: "flex",
                                                              flexDirection:
                                                                "row",
                                                            }}
                                                          >
                                                            <div>
                                                              {poDetails &&
                                                                item.type.toLowerCase() ==
                                                                "order" && (
                                                                  <p
                                                                    style={{
                                                                      fontSize:
                                                                        "13px",
                                                                      fontWeight:
                                                                        "bold",
                                                                    }}
                                                                  >
                                                                    PO:{" "}
                                                                    {item.pono}
                                                                  </p>
                                                                )}
                                                              <p
                                                                style={{
                                                                  fontSize:
                                                                    "13px",
                                                                  fontWeight:
                                                                    "bold",
                                                                }}
                                                              >
                                                                {(customerDetails
                                                                  ? item?.customername +
                                                                  " "
                                                                  : "") +
                                                                  item?.size +
                                                                  " " +
                                                                  item.group +
                                                                  " (" +
                                                                  item.totalSheet +
                                                                  " S" +
                                                                  ", " +
                                                                  item.fulfilledWeight +
                                                                  " " +
                                                                  item.fWeightUnit +
                                                                  ")"}
                                                              </p>
                                                              {consigneeDetails &&
                                                                item.type.toLowerCase() ==
                                                                "order" && (
                                                                  <p
                                                                    style={{
                                                                      fontSize:
                                                                        "13px",
                                                                      fontWeight:
                                                                        "bold",
                                                                    }}
                                                                  >
                                                                    Consignee:{" "}
                                                                    {
                                                                      item.consignee_name
                                                                    }
                                                                  </p>
                                                                )}
                                                              {orderRemarks &&
                                                                item?.remarks.map(
                                                                  (remark) => (
                                                                    <p
                                                                      style={{
                                                                        fontSize:
                                                                          "13px",
                                                                        fontWeight:
                                                                          "bold",
                                                                      }}
                                                                    >
                                                                      {remark
                                                                        ? "Remarks: " +
                                                                        remark
                                                                        : ""}
                                                                    </p>
                                                                  )
                                                                )}
                                                            </div>
                                                          </div>
                                                        )}
                                                      </td>
                                                    </tr>
                                                  )}{" "}
                                                </div>
                                              )
                                            )}{" "}
                                          </table>
                                        </td>
                                        <td
                                          style={{
                                            border: "none",
                                            verticalAlign: "top",
                                          }}
                                        >
                                          <table style={{ border: "none" }}>
                                            {products.orders.map(
                                              (item, index) => (
                                                <div>
                                                  {index % 2 == 1 && (
                                                    <tr
                                                      style={{ border: "none" }}
                                                    >
                                                      <td
                                                        style={{
                                                          border: "none",
                                                          textAlign: "left",
                                                        }}
                                                      >
                                                        {item && (
                                                          <div
                                                            style={{
                                                              display: "flex",
                                                              flexDirection:
                                                                "row",
                                                            }}
                                                          >
                                                            <div>
                                                              {poDetails &&
                                                                item.type.toLowerCase() ==
                                                                "order" && (
                                                                  <p
                                                                    style={{
                                                                      fontSize:
                                                                        "13px",
                                                                      fontWeight:
                                                                        "bold",
                                                                    }}
                                                                  >
                                                                    PO:{" "}
                                                                    {item.pono}
                                                                  </p>
                                                                )}
                                                              <p
                                                                style={{
                                                                  fontSize:
                                                                    "13px",
                                                                  fontWeight:
                                                                    "bold",
                                                                }}
                                                              >
                                                                {(customerDetails
                                                                  ? item?.customername +
                                                                  " "
                                                                  : "") +
                                                                  item?.size +
                                                                  " " +
                                                                  item.group +
                                                                  "(" +
                                                                  item.totalSheet +
                                                                  " S" +
                                                                  ", " +
                                                                  item.fulfilledWeight +
                                                                  " " +
                                                                  item.fWeightUnit +
                                                                  ")"}
                                                              </p>
                                                              {consigneeDetails &&
                                                                item.type.toLowerCase() ==
                                                                "order" && (
                                                                  <p
                                                                    style={{
                                                                      fontSize:
                                                                        "13px",
                                                                      fontWeight:
                                                                        "bold",
                                                                    }}
                                                                  >
                                                                    Consignee:{" "}
                                                                    {
                                                                      item.consignee_name
                                                                    }
                                                                  </p>
                                                                )}
                                                              {orderRemarks &&
                                                                item?.remarks.map(
                                                                  (remark) => (
                                                                    <p
                                                                      style={{
                                                                        fontSize:
                                                                          "13px",
                                                                        fontWeight:
                                                                          "bold",
                                                                      }}
                                                                    >
                                                                      {remark
                                                                        ? "Remarks: " +
                                                                        remark
                                                                        : ""}
                                                                    </p>
                                                                  )
                                                                )}
                                                            </div>
                                                          </div>
                                                        )}
                                                      </td>
                                                    </tr>
                                                  )}{" "}
                                                </div>
                                              )
                                            )}{" "}
                                          </table>
                                        </td>
                                      </tr>
                                    </table>
                                  ))
                                ) : customerDetails ? (
                                  <table
                                    style={{
                                      border: "none",
                                      marginBottom: "40px",
                                    }}
                                  >
                                    <tr style={{ border: "none" }}>
                                      <td
                                        style={{
                                          border: "none",
                                          verticalAlign: "top",
                                        }}
                                      >
                                        <table style={{ border: "none" }}>
                                          {customerWiseOrder.map(
                                            (item, index) => (
                                              <div>
                                                {index % 2 == 0 && (
                                                  <tr
                                                    style={{ border: "none" }}
                                                  >
                                                    <td
                                                      style={{
                                                        border: "none",
                                                        textAlign: "left",
                                                      }}
                                                    >
                                                      {item &&
                                                        customerDetails && (
                                                          <div
                                                            style={{
                                                              display: "flex",
                                                              flexDirection:
                                                                "row",
                                                            }}
                                                          >
                                                            <div>
                                                              {poDetails &&
                                                                item.type.toLowerCase() ==
                                                                "order" && (
                                                                  <p
                                                                    style={{
                                                                      fontSize:
                                                                        "13px",
                                                                      fontWeight:
                                                                        "bold",
                                                                    }}
                                                                  >
                                                                    PO:{" "}
                                                                    {item.pono}
                                                                  </p>
                                                                )}
                                                              <p
                                                                style={{
                                                                  fontSize:
                                                                    "13px",
                                                                  fontWeight:
                                                                    "bold",
                                                                }}
                                                              >
                                                                {(customerDetails
                                                                  ? item?.customername +
                                                                  " "
                                                                  : "") +
                                                                  item?.size +
                                                                  " " +
                                                                  item.group +
                                                                  "(" +
                                                                  item.totalSheet +
                                                                  " S" +
                                                                  ", " +
                                                                  item.fulfilledWeight +
                                                                  " " +
                                                                  item.fWeightUnit +
                                                                  ")"}
                                                              </p>
                                                              {consigneeDetails &&
                                                                item.type.toLowerCase() ==
                                                                "order" && (
                                                                  <p
                                                                    style={{
                                                                      fontSize:
                                                                        "13px",
                                                                      fontWeight:
                                                                        "bold",
                                                                    }}
                                                                  >
                                                                    Consignee:{" "}
                                                                    {
                                                                      item.consignee_name
                                                                    }
                                                                  </p>
                                                                )}

                                                              {orderRemarks &&
                                                                item?.remarks.map(
                                                                  (remark) => (
                                                                    <p
                                                                      style={{
                                                                        fontSize:
                                                                          "13px",
                                                                        fontWeight:
                                                                          "bold",
                                                                      }}
                                                                    >
                                                                      {remark
                                                                        ? "Remarks: " +
                                                                        remark
                                                                        : ""}
                                                                    </p>
                                                                  )
                                                                )}
                                                            </div>
                                                          </div>
                                                        )}
                                                    </td>
                                                  </tr>
                                                )}{" "}
                                              </div>
                                            )
                                          )}{" "}
                                        </table>
                                      </td>
                                      <td
                                        style={{
                                          border: "none",
                                          verticalAlign: "top",
                                        }}
                                      >
                                        <table style={{ border: "none" }}>
                                          {customerWiseOrder.map(
                                            (item, index) => (
                                              <div>
                                                {index % 2 == 1 && (
                                                  <tr
                                                    style={{ border: "none" }}
                                                  >
                                                    <td
                                                      style={{
                                                        border: "none",
                                                        textAlign: "left",
                                                      }}
                                                    >
                                                      {item &&
                                                        customerDetails && (
                                                          <div
                                                            style={{
                                                              display: "flex",
                                                              flexDirection:
                                                                "row",
                                                            }}
                                                          >
                                                            <div>
                                                              {poDetails &&
                                                                item.type.toLowerCase() ==
                                                                "order" && (
                                                                  <p
                                                                    style={{
                                                                      fontSize:
                                                                        "13px",
                                                                      fontWeight:
                                                                        "bold",
                                                                    }}
                                                                  >
                                                                    PO:{" "}
                                                                    {item.pono}
                                                                  </p>
                                                                )}
                                                              <p
                                                                style={{
                                                                  fontSize:
                                                                    "13px",
                                                                  fontWeight:
                                                                    "bold",
                                                                }}
                                                              >
                                                                {(customerDetails
                                                                  ? item?.customername +
                                                                  " "
                                                                  : "") +
                                                                  item?.size +
                                                                  " " +
                                                                  item.group +
                                                                  "(" +
                                                                  item.totalSheet +
                                                                  " S" +
                                                                  ", " +
                                                                  item.fulfilledWeight +
                                                                  " " +
                                                                  item.fWeightUnit +
                                                                  ")"}
                                                              </p>
                                                              {consigneeDetails &&
                                                                item.type.toLowerCase() ==
                                                                "order" && (
                                                                  <p
                                                                    style={{
                                                                      fontSize:
                                                                        "13px",
                                                                      fontWeight:
                                                                        "bold",
                                                                    }}
                                                                  >
                                                                    Consignee:{" "}
                                                                    {
                                                                      item.consignee_name
                                                                    }
                                                                  </p>
                                                                )}

                                                              {orderRemarks &&
                                                                item?.remarks.map(
                                                                  (remark) => (
                                                                    <p
                                                                      style={{
                                                                        fontSize:
                                                                          "13px",
                                                                        fontWeight:
                                                                          "bold",
                                                                      }}
                                                                    >
                                                                      {remark
                                                                        ? "Remarks: " +
                                                                        remark
                                                                        : ""}
                                                                    </p>
                                                                  )
                                                                )}
                                                            </div>
                                                          </div>
                                                        )}
                                                    </td>
                                                  </tr>
                                                )}{" "}
                                              </div>
                                            )
                                          )}{" "}
                                        </table>
                                      </td>
                                    </tr>
                                  </table>
                                ) : consigneeDetails ? (
                                  <table
                                    style={{
                                      border: "none",
                                      marginBottom: "40px",
                                    }}
                                  >
                                    <tr style={{ border: "none" }}>
                                      <td
                                        style={{
                                          border: "none",
                                          verticalAlign: "top",
                                        }}
                                      >
                                        <table style={{ border: "none" }}>
                                          {consigneeWiseOrder.map(
                                            (item, index) => (
                                              <div>
                                                {index % 2 == 0 && (
                                                  <tr
                                                    style={{ border: "none" }}
                                                  >
                                                    <td
                                                      style={{
                                                        border: "none",
                                                        textAlign: "left",
                                                      }}
                                                    >
                                                      {item &&
                                                        consigneeDetails && (
                                                          <div
                                                            style={{
                                                              display: "flex",
                                                              flexDirection:
                                                                "row",
                                                            }}
                                                          >
                                                            <div>
                                                              {poDetails &&
                                                                item.type.toLowerCase() ==
                                                                "order" && (
                                                                  <p
                                                                    style={{
                                                                      fontSize:
                                                                        "13px",
                                                                      fontWeight:
                                                                        "bold",
                                                                    }}
                                                                  >
                                                                    PO:{" "}
                                                                    {item.pono}
                                                                  </p>
                                                                )}
                                                              <p
                                                                style={{
                                                                  fontSize:
                                                                    "13px",
                                                                  fontWeight:
                                                                    "bold",
                                                                }}
                                                              >
                                                                {(customerDetails
                                                                  ? item?.customername +
                                                                  " "
                                                                  : "") +
                                                                  item?.size +
                                                                  " " +
                                                                  item.group +
                                                                  "(" +
                                                                  item.totalSheet +
                                                                  " S" +
                                                                  ", " +
                                                                  item.fulfilledWeight +
                                                                  " " +
                                                                  item.fWeightUnit +
                                                                  ")"}
                                                              </p>
                                                              {consigneeDetails &&
                                                                item.type.toLowerCase() ==
                                                                "order" && (
                                                                  <p
                                                                    style={{
                                                                      fontSize:
                                                                        "13px",
                                                                      fontWeight:
                                                                        "bold",
                                                                    }}
                                                                  >
                                                                    Consignee:{" "}
                                                                    {
                                                                      item.consignee_name
                                                                    }
                                                                  </p>
                                                                )}

                                                              {orderRemarks &&
                                                                item?.remarks.map(
                                                                  (remark) => (
                                                                    <p
                                                                      style={{
                                                                        fontSize:
                                                                          "13px",
                                                                        fontWeight:
                                                                          "bold",
                                                                      }}
                                                                    >
                                                                      {remark
                                                                        ? "Remarks: " +
                                                                        remark
                                                                        : ""}
                                                                    </p>
                                                                  )
                                                                )}
                                                            </div>
                                                          </div>
                                                        )}
                                                    </td>
                                                  </tr>
                                                )}{" "}
                                              </div>
                                            )
                                          )}{" "}
                                        </table>
                                      </td>
                                      <td
                                        style={{
                                          border: "none",
                                          verticalAlign: "top",
                                        }}
                                      >
                                        <table style={{ border: "none" }}>
                                          {consigneeWiseOrder.map(
                                            (item, index) => (
                                              <div>
                                                {index % 2 == 1 && (
                                                  <tr
                                                    style={{ border: "none" }}
                                                  >
                                                    <td
                                                      style={{
                                                        border: "none",
                                                        textAlign: "left",
                                                      }}
                                                    >
                                                      {item &&
                                                        consigneeDetails && (
                                                          <div
                                                            style={{
                                                              display: "flex",
                                                              flexDirection:
                                                                "row",
                                                            }}
                                                          >
                                                            <div>
                                                              {poDetails &&
                                                                item.type.toLowerCase() ==
                                                                "order" && (
                                                                  <p
                                                                    style={{
                                                                      fontSize:
                                                                        "13px",
                                                                      fontWeight:
                                                                        "bold",
                                                                    }}
                                                                  >
                                                                    PO:{" "}
                                                                    {item.pono}
                                                                  </p>
                                                                )}
                                                              <p
                                                                style={{
                                                                  fontSize:
                                                                    "13px",
                                                                  fontWeight:
                                                                    "bold",
                                                                }}
                                                              >
                                                                {(customerDetails
                                                                  ? item?.customername +
                                                                  " "
                                                                  : "") +
                                                                  item?.size +
                                                                  " " +
                                                                  item.group +
                                                                  "(" +
                                                                  item.totalSheet +
                                                                  " S" +
                                                                  ", " +
                                                                  item.fulfilledWeight +
                                                                  " " +
                                                                  item.fWeightUnit +
                                                                  ")"}
                                                              </p>
                                                              {consigneeDetails &&
                                                                item.type.toLowerCase() ==
                                                                "order" && (
                                                                  <p
                                                                    style={{
                                                                      fontSize:
                                                                        "13px",
                                                                      fontWeight:
                                                                        "bold",
                                                                    }}
                                                                  >
                                                                    Consignee:{" "}
                                                                    {
                                                                      item.consignee_name
                                                                    }
                                                                  </p>
                                                                )}

                                                              {orderRemarks &&
                                                                item?.remarks.map(
                                                                  (remark) => (
                                                                    <p
                                                                      style={{
                                                                        fontSize:
                                                                          "13px",
                                                                        fontWeight:
                                                                          "bold",
                                                                      }}
                                                                    >
                                                                      {remark
                                                                        ? "Remarks: " +
                                                                        remark
                                                                        : ""}
                                                                    </p>
                                                                  )
                                                                )}
                                                            </div>
                                                          </div>
                                                        )}
                                                    </td>
                                                  </tr>
                                                )}{" "}
                                              </div>
                                            )
                                          )}{" "}
                                        </table>
                                      </td>
                                    </tr>
                                  </table>
                                ) : poDetails ? (
                                  <table
                                    style={{
                                      border: "none",
                                      marginBottom: "40px",
                                    }}
                                  >
                                    <tr style={{ border: "none" }}>
                                      <td
                                        style={{
                                          border: "none",
                                          verticalAlign: "top",
                                        }}
                                      >
                                        <table style={{ border: "none" }}>
                                          {poWiseOrder.map((item, index) => (
                                            <div>
                                              {index % 2 == 0 && (
                                                <tr style={{ border: "none" }}>
                                                  <td
                                                    style={{
                                                      border: "none",
                                                      textAlign: "left",
                                                    }}
                                                  >
                                                    {item && poDetails && (
                                                      <div
                                                        style={{
                                                          display: "flex",
                                                          flexDirection: "row",
                                                        }}
                                                      >
                                                        <div>
                                                          {poDetails &&
                                                            item.type.toLowerCase() ==
                                                            "order" && (
                                                              <p
                                                                style={{
                                                                  fontSize:
                                                                    "13px",
                                                                  fontWeight:
                                                                    "bold",
                                                                }}
                                                              >
                                                                PO: {item.pono}
                                                              </p>
                                                            )}
                                                          <p
                                                            style={{
                                                              fontSize: "13px",
                                                              fontWeight:
                                                                "bold",
                                                            }}
                                                          >
                                                            {(customerDetails
                                                              ? item?.customername +
                                                              " "
                                                              : "") +
                                                              item?.size +
                                                              " " +
                                                              item.group +
                                                              "(" +
                                                              item.totalSheet +
                                                              " S" +
                                                              ", " +
                                                              item.fulfilledWeight +
                                                              " " +
                                                              item.fWeightUnit +
                                                              ")"}
                                                          </p>
                                                          {consigneeDetails &&
                                                            item.type.toLowerCase() ==
                                                            "order" && (
                                                              <p
                                                                style={{
                                                                  fontSize:
                                                                    "13px",
                                                                  fontWeight:
                                                                    "bold",
                                                                }}
                                                              >
                                                                Consignee:{" "}
                                                                {
                                                                  item.consignee_name
                                                                }
                                                              </p>
                                                            )}

                                                          {orderRemarks &&
                                                            item?.remarks.map(
                                                              (remark) => (
                                                                <p
                                                                  style={{
                                                                    fontSize:
                                                                      "13px",
                                                                    fontWeight:
                                                                      "bold",
                                                                  }}
                                                                >
                                                                  {remark
                                                                    ? "Remarks: " +
                                                                    remark
                                                                    : ""}
                                                                </p>
                                                              )
                                                            )}
                                                        </div>
                                                      </div>
                                                    )}
                                                  </td>
                                                </tr>
                                              )}{" "}
                                            </div>
                                          ))}{" "}
                                        </table>
                                      </td>
                                      <td
                                        style={{
                                          border: "none",
                                          verticalAlign: "top",
                                        }}
                                      >
                                        <table style={{ border: "none" }}>
                                          {poWiseOrder.map((item, index) => (
                                            <div>
                                              {index % 2 == 1 && (
                                                <tr style={{ border: "none" }}>
                                                  <td
                                                    style={{
                                                      border: "none",
                                                      textAlign: "left",
                                                    }}
                                                  >
                                                    {item && poDetails && (
                                                      <div
                                                        style={{
                                                          display: "flex",
                                                          flexDirection: "row",
                                                        }}
                                                      >
                                                        <div>
                                                          {poDetails &&
                                                            item.type.toLowerCase() ==
                                                            "order" && (
                                                              <p
                                                                style={{
                                                                  fontSize:
                                                                    "13px",
                                                                  fontWeight:
                                                                    "bold",
                                                                }}
                                                              >
                                                                PO: {item.pono}
                                                              </p>
                                                            )}
                                                          <p
                                                            style={{
                                                              fontSize: "13px",
                                                              fontWeight:
                                                                "bold",
                                                            }}
                                                          >
                                                            {(customerDetails
                                                              ? item?.customername +
                                                              " "
                                                              : "") +
                                                              item?.size +
                                                              " " +
                                                              item.group +
                                                              "(" +
                                                              item.totalSheet +
                                                              " S" +
                                                              ", " +
                                                              item.fulfilledWeight +
                                                              " " +
                                                              item.fWeightUnit +
                                                              ")"}
                                                          </p>
                                                          {consigneeDetails &&
                                                            item.type.toLowerCase() ==
                                                            "order" && (
                                                              <p
                                                                style={{
                                                                  fontSize:
                                                                    "13px",
                                                                  fontWeight:
                                                                    "bold",
                                                                }}
                                                              >
                                                                Consignee:{" "}
                                                                {
                                                                  item.consignee_name
                                                                }
                                                              </p>
                                                            )}

                                                          {orderRemarks &&
                                                            item?.remarks.map(
                                                              (remark) => (
                                                                <p
                                                                  style={{
                                                                    fontSize:
                                                                      "13px",
                                                                    fontWeight:
                                                                      "bold",
                                                                  }}
                                                                >
                                                                  {remark
                                                                    ? "Remarks: " +
                                                                    remark
                                                                    : ""}
                                                                </p>
                                                              )
                                                            )}
                                                        </div>
                                                      </div>
                                                    )}
                                                  </td>
                                                </tr>
                                              )}{" "}
                                            </div>
                                          ))}{" "}
                                        </table>
                                      </td>
                                    </tr>
                                  </table>
                                ) : (
                                  <table
                                    style={{
                                      border: "none",
                                      marginBottom: "40px",
                                    }}
                                  >
                                    <tr style={{ border: "none" }}>
                                      <td
                                        style={{
                                          border: "none",
                                          verticalAlign: "top",
                                        }}
                                      >
                                        <table style={{ border: "none" }}>
                                          {sheetOrder.map((item, index) => (
                                            <div>
                                              {index % 2 == 0 && (
                                                <tr style={{ border: "none" }}>
                                                  <td
                                                    style={{
                                                      border: "none",
                                                      textAlign: "left",
                                                    }}
                                                  >
                                                    {item && (
                                                      <div
                                                        style={{
                                                          display: "flex",
                                                          flexDirection: "row",
                                                        }}
                                                      >
                                                        <div>
                                                          {poDetails &&
                                                            item.type.toLowerCase() ==
                                                            "order" && (
                                                              <p
                                                                style={{
                                                                  fontSize:
                                                                    "13px",
                                                                  fontWeight:
                                                                    "bold",
                                                                }}
                                                              >
                                                                PO: {item.pono}
                                                              </p>
                                                            )}
                                                          <p
                                                            style={{
                                                              fontSize: "13px",
                                                              fontWeight:
                                                                "bold",
                                                            }}
                                                          >
                                                            {(customerDetails
                                                              ? item?.customername +
                                                              " "
                                                              : "") +
                                                              item?.size +
                                                              " " +
                                                              item.group +
                                                              "(" +
                                                              item.totalSheet +
                                                              " S" +
                                                              ", " +
                                                              item.fulfilledWeight +
                                                              " " +
                                                              item.fWeightUnit +
                                                              ")"}
                                                          </p>
                                                          {consigneeDetails &&
                                                            item.type.toLowerCase() ==
                                                            "order" && (
                                                              <p
                                                                style={{
                                                                  fontSize:
                                                                    "13px",
                                                                  fontWeight:
                                                                    "bold",
                                                                }}
                                                              >
                                                                Consignee:{" "}
                                                                {
                                                                  item.consignee_name
                                                                }
                                                              </p>
                                                            )}

                                                          {orderRemarks &&
                                                            item?.remarks.map(
                                                              (remark) => (
                                                                <p
                                                                  style={{
                                                                    fontSize:
                                                                      "13px",
                                                                    fontWeight:
                                                                      "bold",
                                                                  }}
                                                                >
                                                                  {remark
                                                                    ? "Remarks: " +
                                                                    remark
                                                                    : ""}
                                                                </p>
                                                              )
                                                            )}
                                                        </div>
                                                      </div>
                                                    )}
                                                  </td>
                                                </tr>
                                              )}{" "}
                                            </div>
                                          ))}{" "}
                                        </table>
                                      </td>
                                      <td
                                        style={{
                                          border: "none",
                                          verticalAlign: "top",
                                        }}
                                      >
                                        <table style={{ border: "none" }}>
                                          {sheetOrder.map((item, index) => (
                                            <div>
                                              {index % 2 == 1 && (
                                                <tr style={{ border: "none" }}>
                                                  <td
                                                    style={{
                                                      border: "none",
                                                      textAlign: "left",
                                                    }}
                                                  >
                                                    {item && (
                                                      <div
                                                        style={{
                                                          display: "flex",
                                                          flexDirection: "row",
                                                        }}
                                                      >
                                                        <div>
                                                          {poDetails &&
                                                            item.type.toLowerCase() ==
                                                            "order" && (
                                                              <p
                                                                style={{
                                                                  fontSize:
                                                                    "13px",
                                                                  fontWeight:
                                                                    "bold",
                                                                }}
                                                              >
                                                                PO: {item.pono}
                                                              </p>
                                                            )}
                                                          <p
                                                            style={{
                                                              fontSize: "13px",
                                                              fontWeight:
                                                                "bold",
                                                            }}
                                                          >
                                                            {(customerDetails
                                                              ? item?.customername +
                                                              " "
                                                              : "") +
                                                              item?.size +
                                                              " " +
                                                              item.group +
                                                              "(" +
                                                              item.totalSheet +
                                                              " S" +
                                                              ", " +
                                                              item.fulfilledWeight +
                                                              " " +
                                                              item.fWeightUnit +
                                                              ")"}
                                                          </p>
                                                          {consigneeDetails &&
                                                            item.type.toLowerCase() ==
                                                            "order" && (
                                                              <p
                                                                style={{
                                                                  fontSize:
                                                                    "13px",
                                                                  fontWeight:
                                                                    "bold",
                                                                }}
                                                              >
                                                                Consignee:{" "}
                                                                {
                                                                  item.consignee_name
                                                                }
                                                              </p>
                                                            )}

                                                          {orderRemarks &&
                                                            item?.remarks.map(
                                                              (remark) => (
                                                                <p
                                                                  style={{
                                                                    fontSize:
                                                                      "13px",
                                                                    fontWeight:
                                                                      "bold",
                                                                  }}
                                                                >
                                                                  {remark
                                                                    ? "Remarks: " +
                                                                    remark
                                                                    : ""}
                                                                </p>
                                                              )
                                                            )}
                                                        </div>
                                                      </div>
                                                    )}
                                                  </td>
                                                </tr>
                                              )}{" "}
                                            </div>
                                          ))}{" "}
                                        </table>
                                      </td>
                                    </tr>
                                  </table>
                                )}
                              </div>
                              {/* ))} */}
                            </ExportTableForm1>
                          </div>
                        )}
                        {selectedFormat === "format_2" && dataSet && (
                          <div>
                            <ExportAdditional>
                              <div className="export-additional">
                                <div
                                  className="additional-col-format-1"
                                  style={{ width: "60px" }}
                                >
                                  <p
                                    style={{
                                      fontWeight: "bold",
                                      fontSize: "13px",
                                      marginBottom: "0em",
                                      wordWrap: "break-word",
                                    }}
                                  >
                                    Grade: {jobCard.group.grouping_params.grade}
                                  </p>
                                  <p style={{ marginBottom: "0em" }}>
                                    Weight:{" "}
                                    {acceptedSolution.solution?.summary?.job_card_weight?.toFixed(
                                      2
                                    )}{" "}
                                  </p>
                                  <p style={{ marginBottom: "0em" }}>
                                    GSM:{jobCard.group.grouping_params.gsm}{" "}
                                  </p>
                                </div>
                                <div className="additional-col-format-1">
                                  <p
                                    style={{
                                      fontWeight: "bold",
                                      fontSize: "13px",
                                      marginBottom: "0em",
                                      wordWrap: "break-word",
                                    }}
                                  >
                                    Quality:{" "}
                                    {jobCard.group.grouping_params.quality}
                                  </p>
                                  <p style={{ marginBottom: "0em" }}>
                                    Unique Set:{" "}
                                    {
                                      acceptedSolution.solution.summary
                                        .total_unique_patterns
                                    }
                                  </p>
                                  {jobCard.group.grouping_params.moisture ? (
                                    <p style={{ marginBottom: "0em" }}>
                                      Moisture:
                                      {jobCard.group.grouping_params.moisture}
                                    </p>
                                  ) : null}
                                </div>
                                <div className="additional-col-format-1">
                                  <p
                                    style={{
                                      fontWeight: "bold",
                                      fontSize: "13px",
                                      marginBottom: "0em",
                                    }}
                                  >
                                    Trim Loss:{" "}
                                    {acceptedSolution.solution.summary.match_trimloss_percent_width.toFixed(
                                      3
                                    )}
                                    %
                                  </p>
                                  <p style={{ marginBottom: "0em" }}>
                                    Sheet:{" "}
                                    {acceptedSolution.solution.summary
                                      .fulfillment_priority_fulfillment_quantity +
                                      acceptedSolution.solution.summary
                                        .fulfillment_standard_fulfillment_quantity +
                                      acceptedSolution.solution.summary
                                        .fulfillment_optional_fulfillment_quantity +
                                      acceptedSolution.solution.summary
                                        .fulfillment_stock_fulfillment_quantity}
                                  </p>
                                </div>
                                <div className="additional-col-format-1">
                                  <p
                                    style={{
                                      fontWeight: "bold",
                                      fontSize: "13px",
                                      marginBottom: "0em",
                                    }}
                                  >
                                    Fulfillment:{" "}
                                    {acceptedSolution.solution.summary.total_fulfillment_percent.toFixed(
                                      3
                                    )}
                                    %
                                  </p>
                                  <p style={{ marginBottom: "0em" }}>
                                    Priority Sheet:{" "}
                                    {
                                      acceptedSolution.solution.summary
                                        .fulfillment_priority_fulfillment_quantity
                                    }
                                  </p>
                                </div>
                              </div>
                            </ExportAdditional>
                            {jobCardSummary.group && msgVisible && (
                              <ExportNote>
                                <div className="export-additional">
                                  <p
                                    style={{
                                      marginBottom: "0em",
                                      fontSize: "13px",
                                    }}
                                  >
                                    Note: Multiple groups were merged while creating this job card.
                                  </p>
                                </div>
                              </ExportNote>
                            )}
                            <ExportTable>
                              {dataSet.map((item) => (
                                <div style={{ marginBottom: "10px" }}>
                                  <table>
                                    <thead>
                                      <tr>
                                        <th>EDGE TRIM (L)</th>
                                        {/* {item.orderWidthArray.map((order, index) => (
                                      <th>{index + 1}</th>))}*/}
                                        {orderWidthArr.map((order, index) => (
                                          <th>{index + 1}</th>
                                        ))}
                                        <th>D.COM. WIDTH</th>
                                        <th>CHOP</th>
                                        <th>TRIM</th>
                                        <th>EDGE TRIM (R)</th>
                                        <th>NET TRIM</th>
                                        <th>Quantity</th>
                                        <th>Sets Weight</th>

                                        <th>Earliest DEL. DATE</th>
                                      </tr>
                                    </thead>

                                    <tbody>
                                      <tr>
                                        <td>
                                          <p className="reel f-10">
                                            {item.leftTrim}{" "}
                                            {jobCard.group.machines[0].units
                                              ?.left_edge_trim
                                              ? lengthUnit[
                                                jobCard.group.machines[0]
                                                  .units?.left_edge_trim
                                              ].displayName.toUpperCase()
                                              : "CM"}
                                          </p>
                                        </td>

                                        {orderWidthArr.map((order, index) => (
                                          <td
                                            className={
                                              item?.widthData[index]?.priority
                                                ? "priority"
                                                : ""
                                            }
                                          >
                                            <p className="reel f-10">
                                              {(item?.widthData[index]?.width
                                                ? item?.widthData[index]?.width
                                                : "") +
                                                (item?.widthData[index]
                                                  ?.priority
                                                  ? "*"
                                                  : "")}
                                            </p>
                                          </td>
                                        ))}
                                        <td>
                                          <p className="reel f-10">
                                            {item.totalWidth}{" "}
                                            {item.units?.breadth
                                              ? lengthUnit[
                                                item.units.breadth
                                              ].displayName.toUpperCase()
                                              : "CM"}
                                          </p>
                                        </td>
                                        <td>
                                          <p className="reel f-10">
                                            {item.chop}{" "}
                                            {item.units?.length
                                              ? lengthUnit[
                                                item.units.length
                                              ].displayName.toUpperCase()
                                              : "CM"}
                                          </p>
                                        </td>
                                        <td>
                                          <p className="reel f-10">
                                            {item.trim}{" "}
                                            {jobCard.group.machines[0].units
                                              ?.trim_loss_width
                                              ? lengthUnit[
                                                jobCard.group.machines[0]
                                                  .units?.trim_loss_width
                                              ].displayName.toUpperCase()
                                              : "CM"}
                                          </p>
                                        </td>

                                        <td>
                                          <p className="reel f-10">
                                            {item.rightTrim}{" "}
                                            {jobCard.group.machines[0].units
                                              ?.right_edge_trim
                                              ? lengthUnit[
                                                jobCard.group.machines[0]
                                                  .units?.right_edge_trim
                                              ].displayName.toUpperCase()
                                              : "CM"}
                                          </p>
                                        </td>

                                        <td>
                                          <p className="reel f-10">
                                            {(
                                              item.leftTrim +
                                              item.trim +
                                              item.rightTrim
                                            ).toFixed(3)}{" "}
                                            {jobCard.group.machines[0].units
                                              ?.right_edge_trim
                                              ? lengthUnit[
                                                jobCard.group.machines[0]
                                                  .units?.right_edge_trim
                                              ].displayName.toUpperCase()
                                              : "CM"}
                                          </p>
                                        </td>

                                        <td>
                                          <p className="reel f-10">
                                            {item.quantity}
                                          </p>
                                        </td>
                                        <td>
                                          <p className="reel f-10">
                                            {item.weight} {""}{" "}
                                            {item.units?.weight
                                              ? capitalize(
                                                weightUnit[item.units.weight]
                                                  .displayName
                                              )
                                              : "T"}
                                          </p>
                                        </td>

                                        <td>
                                          <p className="reel f-10">
                                            {item.deldate}
                                          </p>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                  {item.burstFactorWiseInfo.map((orders) => (
                                    <div
                                      className="statusVal"
                                      style={{
                                        display: "flex",
                                        flexDirection: "column",
                                      }}
                                    >
                                      <table style={{ border: "none" }}>
                                        <tr style={{ border: "none" }}>
                                          <td
                                            rowSpan={
                                              orders.orders.length / 2 + 2
                                            }
                                            style={{
                                              border: "none",
                                              width: "18%",
                                              verticalAlign: "top",
                                            }}
                                          >
                                            <p
                                              className="reel f-12-bold"
                                              style={{
                                                backgroundColor: "lightgray",
                                                alignSelf: "start",
                                              }}
                                            >
                                              {orders?.burst_factor} BF /{" "}
                                              {orders.gsm} GSM{" "}
                                            </p>
                                          </td>
                                        </tr>
                                        <tr style={{ border: "none" }}>
                                          <td
                                            style={{
                                              border: "none",
                                              verticalAlign: "top",
                                            }}
                                          >
                                            <table style={{ border: "none" }}>
                                              {orders.orders.map(
                                                (order, index) => (
                                                  <div>
                                                    {index % 2 == 0 && (
                                                      <tr
                                                        style={{
                                                          border: "none",
                                                        }}
                                                      >
                                                        <td
                                                          style={{
                                                            border: "none",
                                                            textAlign: "left",
                                                          }}
                                                        >
                                                          {item && (
                                                            <div
                                                              style={{
                                                                display: "flex",
                                                                flexDirection:
                                                                  "row",
                                                              }}
                                                            >
                                                              <div>
                                                                <p className="reel f-11">
                                                                  {order?.customername +
                                                                    " " +
                                                                    order?.size +
                                                                    " " +
                                                                    order.group +
                                                                    " (" +
                                                                    order.totalSheet2 +
                                                                    " S" +
                                                                    ", " +
                                                                    (
                                                                      (conversionFactorTonneToUnits[
                                                                        unitData
                                                                          .units_management
                                                                          .weight
                                                                          .default
                                                                      ] *
                                                                        (order.length *
                                                                          (order
                                                                            .units
                                                                            ?.length
                                                                            ? CoversionFactorUnitsToCM[
                                                                            order
                                                                              .units
                                                                              ?.length
                                                                            ]
                                                                            : 1) *
                                                                          order.width *
                                                                          (order
                                                                            .units
                                                                            ?.width
                                                                            ? CoversionFactorUnitsToCM[
                                                                            order
                                                                              .units
                                                                              ?.width
                                                                            ]
                                                                            : 1) *
                                                                          order.no_of_sheets *
                                                                          order
                                                                            .productInfo
                                                                            .gsm)) /
                                                                      10000000000
                                                                    ).toFixed(
                                                                      3
                                                                    ) +
                                                                    " " +
                                                                    (order.units
                                                                      ? capitalize(
                                                                        weightUnit[
                                                                          unitData
                                                                            .units_management
                                                                            .weight
                                                                            .default
                                                                        ]
                                                                          .displayName
                                                                      )
                                                                      : "T") +
                                                                    ")"}
                                                                </p>

                                                                <p className="reel f-10">
                                                                  {order.remarks
                                                                    ? "Remarks: " +
                                                                    order.remarks
                                                                    : ""}
                                                                </p>
                                                              </div>
                                                            </div>
                                                          )}
                                                        </td>
                                                      </tr>
                                                    )}{" "}
                                                  </div>
                                                )
                                              )}{" "}
                                            </table>
                                          </td>
                                          <td
                                            style={{
                                              border: "none",
                                              verticalAlign: "top",
                                            }}
                                          >
                                            <table style={{ border: "none" }}>
                                              {orders.orders.map(
                                                (order, index) => (
                                                  <div>
                                                    {index % 2 == 1 && (
                                                      <tr
                                                        style={{
                                                          border: "none",
                                                        }}
                                                      >
                                                        <td
                                                          style={{
                                                            border: "none",
                                                            textAlign: "left",
                                                          }}
                                                        >
                                                          {order && (
                                                            <div
                                                              style={{
                                                                display: "flex",
                                                                flexDirection:
                                                                  "row",
                                                              }}
                                                            >
                                                              <div>
                                                                <p className="reel f-11">
                                                                  {order?.customername +
                                                                    " " +
                                                                    order?.size +
                                                                    " " +
                                                                    order.group +
                                                                    "(" +
                                                                    order.totalSheet2 +
                                                                    " S" +
                                                                    ", " +
                                                                    (
                                                                      (conversionFactorTonneToUnits[
                                                                        unitData
                                                                          .units_management
                                                                          .weight
                                                                          .default
                                                                      ] *
                                                                        (order.length *
                                                                          (order
                                                                            .units
                                                                            ?.length
                                                                            ? CoversionFactorUnitsToCM[
                                                                            order
                                                                              .units
                                                                              ?.length
                                                                            ]
                                                                            : 1) *
                                                                          order.width *
                                                                          (order
                                                                            .units
                                                                            ?.width
                                                                            ? CoversionFactorUnitsToCM[
                                                                            order
                                                                              .units
                                                                              ?.width
                                                                            ]
                                                                            : 1) *
                                                                          order.no_of_sheets *
                                                                          order
                                                                            .productInfo
                                                                            .gsm)) /
                                                                      10000000000
                                                                    ).toFixed(
                                                                      3
                                                                    ) +
                                                                    " " +
                                                                    (order.units
                                                                      ? capitalize(
                                                                        weightUnit[
                                                                          unitData
                                                                            .units_management
                                                                            .weight
                                                                            .default
                                                                        ]
                                                                          .displayName
                                                                      )
                                                                      : "T") +
                                                                    ")"}
                                                                </p>

                                                                <p className="reel f-10">
                                                                  {order.remarks
                                                                    ? "Remarks: " +
                                                                    order.remarks
                                                                    : ""}
                                                                </p>
                                                              </div>
                                                            </div>
                                                          )}
                                                        </td>
                                                      </tr>
                                                    )}{" "}
                                                  </div>
                                                )
                                              )}{" "}
                                            </table>
                                          </td>
                                        </tr>
                                      </table>
                                      <table style={{ border: "none" }}>
                                        <tr style={{ border: "none" }}>
                                          <td
                                            style={{
                                              border: "none",
                                              width: "18%",
                                            }}
                                          >
                                            Comments:
                                          </td>
                                          <td
                                            colSpan={4}
                                            style={{ border: "none" }}
                                          >
                                            <Input
                                              style={{
                                                textTransform: "capitalize",
                                              }}
                                            />
                                          </td>
                                        </tr>
                                      </table>
                                    </div>
                                  ))}
                                </div>
                              ))}
                            </ExportTable>
                          </div>
                        )}
                        {selectedFormat === "format_3" && dataSet && (
                          <div>
                            <ExportAdditional>
                              <div className="export-additional">
                                <div
                                  className="additional-col-format-1"
                                  style={{ width: "60px" }}
                                >
                                  <p
                                    style={{
                                      fontWeight: "bold",
                                      fontSize: "15px",
                                      marginBottom: "0em",
                                      wordWrap: "break-word",
                                    }}
                                  >
                                    Grade: {jobCard.group.grouping_params.grade}
                                  </p>
                                  <p
                                    style={{
                                      marginBottom: "0em",
                                      fontSize: "15px",
                                    }}
                                  >
                                    Weight:{" "}
                                    {acceptedSolution.solution?.summary?.job_card_weight?.toFixed(
                                      2
                                    )}{" "}
                                    {acceptedSolution.solution?.summary?.units
                                      ?.job_card_weight
                                      ? capitalize(
                                        weightUnit[
                                          acceptedSolution.solution?.summary
                                            ?.units?.job_card_weight
                                        ].displayName
                                      )
                                      : "T"}{" "}
                                  </p>
                                  <p
                                    style={{
                                      marginBottom: "0em",
                                      fontSize: "15px",
                                    }}
                                  >
                                    GSM:{jobCard.group.grouping_params.gsm}{" "}
                                  </p>
                                </div>
                                <div className="additional-col-format-1">
                                  <p
                                    style={{
                                      fontWeight: "bold",
                                      fontSize: "15px",
                                      marginBottom: "0em",
                                      wordWrap: "break-word",
                                    }}
                                  >
                                    Quality:{" "}
                                    {jobCard.group.grouping_params.quality}
                                  </p>
                                  <p
                                    style={{
                                      marginBottom: "0em",
                                      fontSize: "15px",
                                    }}
                                  >
                                    Unique Set:{" "}
                                    {
                                      acceptedSolution.solution.summary
                                        .total_unique_patterns
                                    }
                                  </p>
                                  {jobCard.group.grouping_params.moisture ? (
                                    <p
                                      style={{
                                        marginBottom: "0em",
                                        fontSize: "15px",
                                      }}
                                    >
                                      Moisture:
                                      {jobCard.group.grouping_params.moisture}
                                    </p>
                                  ) : null}
                                </div>
                                <div className="additional-col-format-1">
                                  <p
                                    style={{
                                      fontWeight: "bold",
                                      fontSize: "15px",
                                      marginBottom: "0em",
                                    }}
                                  >
                                    Trim Loss:{" "}
                                    {acceptedSolution.solution.summary.match_trimloss_percent_width.toFixed(
                                      3
                                    )}{" "}
                                    %
                                  </p>
                                  <p
                                    style={{
                                      marginBottom: "0em",
                                      fontSize: "15px",
                                    }}
                                  >
                                    Sheet:{" "}
                                    {acceptedSolution.solution.summary
                                      .fulfillment_priority_fulfillment_quantity +
                                      acceptedSolution.solution.summary
                                        .fulfillment_standard_fulfillment_quantity +
                                      acceptedSolution.solution.summary
                                        .fulfillment_optional_fulfillment_quantity +
                                      acceptedSolution.solution.summary
                                        .fulfillment_stock_fulfillment_quantity}
                                  </p>
                                </div>
                                <div className="additional-col-format-1">
                                  <p
                                    style={{
                                      fontWeight: "bold",
                                      fontSize: "15px",
                                      marginBottom: "0em",
                                    }}
                                  >
                                    Fulfillment:{" "}
                                    {acceptedSolution.solution.summary.total_fulfillment_percent.toFixed(
                                      3
                                    )}
                                    %
                                  </p>
                                  <p
                                    style={{
                                      marginBottom: "0em",
                                      fontSize: "15px",
                                    }}
                                  >
                                    Priority Sheet:{" "}
                                    {
                                      acceptedSolution.solution.summary
                                        .fulfillment_priority_fulfillment_quantity
                                    }
                                  </p>
                                </div>
                              </div>
                            </ExportAdditional>
                            {jobCardSummary.group && msgVisible && (
                              <ExportNote>
                                <div className="export-additional">
                                  <p
                                    style={{
                                      marginBottom: "0em",
                                      fontSize: "13px",
                                    }}
                                  >
                                    Note: Multiple groups were merged while creating this job card.
                                  </p>
                                </div>
                              </ExportNote>
                            )}
                            <ExportTableForm1>
                              <div style={{ marginBottom: "10px" }}>
                                <label
                                  style={{
                                    fontStyle: "italic",
                                    fontSize: "smaller",
                                    paddingLeft: "72%",
                                  }}
                                >
                                  *Sizes in coloured cells are priority sizes
                                </label>
                                <table>
                                  <thead>
                                    <tr>
                                      {edgeTrim && (
                                        <th style={{ fontSize: "12px" }}>
                                          EDGE TRIM (L)
                                        </th>
                                      )}
                                      {orderWidthArr.map((order, index) => (
                                        <th style={{ fontSize: "12px" }}>
                                          {index + 1}
                                        </th>
                                      ))}
                                      <th style={{ fontSize: "12px" }}>
                                        D.COM. WIDTH
                                      </th>
                                      <th style={{ fontSize: "12px" }}>CHOP</th>
                                      <th style={{ fontSize: "12px" }}>TRIM</th>
                                      {edgeTrim && (
                                        <th style={{ fontSize: "12px" }}>
                                          EDGE TRIM (R)
                                        </th>
                                      )}
                                      {netTrim && (
                                        <th style={{ fontSize: "12px" }}>
                                          NET TRIM
                                        </th>
                                      )}
                                      <th style={{ fontSize: "12px" }}>
                                        Quantity
                                      </th>
                                      <th style={{ fontSize: "12px" }}>
                                        Sets Weight
                                      </th>
                                    </tr>
                                  </thead>
                                  {(() => {
                                    // Combine rows with identical pattern (widthData + chop + trim)
                                    const grpMap = new Map();
                                    (dataSet || []).forEach((item) => {
                                      const key =
                                        JSON.stringify(
                                          item.widthData.map((w) => ({
                                            width: w.width,
                                            priority: w.priority,
                                            type: w.type,
                                          }))
                                        ) +
                                        "|" +
                                        item.chop +
                                        "|" +
                                        item.trim;
                                      if (grpMap.has(key)) {
                                        const existing = grpMap.get(key);
                                        existing.quantity += item.quantity;
                                        existing.weight = (
                                          parseFloat(existing.weight) +
                                          parseFloat(item.weight)
                                        ).toFixed(3);
                                      } else {
                                        grpMap.set(key, { ...item });
                                      }
                                    });
                                    return Array.from(grpMap.values()).map(
                                      (item) => (
                                        <tbody>
                                          <tr>
                                            {edgeTrim && (
                                              <td>
                                                <p
                                                  style={{
                                                    fontWeight: "bold",
                                                    fontSize: "12px !important",
                                                    color: "#605e5c",
                                                    fontStyle: "italic",
                                                  }}
                                                >
                                                  {item.leftTrim}{" "}
                                                  {jobCard.group.machines[0]
                                                    .units?.left_edge_trim
                                                    ? lengthUnit[
                                                      jobCard.group
                                                        .machines[0].units
                                                        ?.left_edge_trim
                                                    ].displayName.toUpperCase()
                                                    : "CM"}
                                                </p>
                                              </td>
                                            )}
                                            {orderWidthArr.map(
                                              (order, index) => (
                                                <td
                                                  className={
                                                    item?.widthData[index]
                                                      ?.priority &&
                                                      item?.widthData[index]
                                                        ?.type === "order"
                                                      ? "priority"
                                                      : ""
                                                  }
                                                >
                                                  <p
                                                    style={{
                                                      fontWeight: "bold",
                                                      fontSize:
                                                        "12px !important",
                                                      color: "#605e5c",
                                                      fontStyle: "italic",
                                                    }}
                                                  >
                                                    {(item?.widthData[index]
                                                      ?.width
                                                      ? item?.widthData[index]
                                                        ?.width
                                                      : "") +
                                                      (item?.widthData[index]
                                                        ?.priority
                                                        ? "*"
                                                        : "")}
                                                  </p>
                                                </td>
                                              )
                                            )}
                                            <td>
                                              <p
                                                style={{
                                                  fontWeight: "bold",
                                                  fontSize: "12px !important",
                                                  color: "#605e5c",
                                                  fontStyle: "italic",
                                                }}
                                              >
                                                {item.totalWidth}{" "}
                                                {item.units?.breadth
                                                  ? lengthUnit[
                                                    item.units.breadth
                                                  ].displayName.toUpperCase()
                                                  : "CM"}
                                              </p>
                                            </td>
                                            <td>
                                              <p
                                                style={{
                                                  fontWeight: "bold",
                                                  fontSize: "12px !important",
                                                  color: "#605e5c",
                                                  fontStyle: "italic",
                                                }}
                                              >
                                                {item.chop}{" "}
                                                {item.units?.length
                                                  ? lengthUnit[
                                                    item.units.length
                                                  ].displayName.toUpperCase()
                                                  : "CM"}
                                              </p>
                                            </td>
                                            <td>
                                              <p
                                                style={{
                                                  fontWeight: "bold",
                                                  fontSize: "12px !important",
                                                  color: "#605e5c",
                                                  fontStyle: "italic",
                                                }}
                                              >
                                                {item.trim}{" "}
                                                {item.units?.trim_loss_width
                                                  ? lengthUnit[
                                                    item.units.trim_loss_width
                                                  ].displayName.toUpperCase()
                                                  : "CM"}
                                              </p>
                                            </td>
                                            {edgeTrim && (
                                              <td>
                                                <p
                                                  style={{
                                                    fontWeight: "bold",
                                                    fontSize: "12px !important",
                                                    color: "#605e5c",
                                                    fontStyle: "italic",
                                                  }}
                                                >
                                                  {item.rightTrim}{" "}
                                                  {jobCard.group.machines[0]
                                                    .units?.right_edge_trim
                                                    ? lengthUnit[
                                                      jobCard.group
                                                        .machines[0].units
                                                        ?.right_edge_trim
                                                    ].displayName.toUpperCase()
                                                    : "CM"}
                                                </p>
                                              </td>
                                            )}
                                            {netTrim && (
                                              <td>
                                                <p
                                                  style={{
                                                    fontWeight: "bold",
                                                    fontSize: "12px !important",
                                                    color: "#605e5c",
                                                    fontStyle: "italic",
                                                  }}
                                                >
                                                  {(
                                                    item.leftTrim +
                                                    item.trim +
                                                    item.rightTrim
                                                  ).toFixed(3)}{" "}
                                                  {jobCard.group.machines[0]
                                                    .units?.right_edge_trim
                                                    ? lengthUnit[
                                                      jobCard.group
                                                        .machines[0].units
                                                        ?.right_edge_trim
                                                    ].displayName.toUpperCase()
                                                    : "CM"}
                                                </p>
                                              </td>
                                            )}
                                            <td>
                                              <p
                                                style={{
                                                  fontWeight: "bold",
                                                  fontSize: "12px !important",
                                                  color: "#605e5c",
                                                  fontStyle: "italic",
                                                }}
                                              >
                                                {item.quantity}
                                              </p>
                                            </td>
                                            <td>
                                              <p
                                                style={{
                                                  fontWeight: "bold",
                                                  fontSize: "12px !important",
                                                  color: "#605e5c",
                                                  fontStyle: "italic",
                                                }}
                                              >
                                                {item.weight}{" "}
                                                {item.units?.weight
                                                  ? capitalize(
                                                    weightUnit[
                                                      item.units.weight
                                                    ].displayName
                                                  )
                                                  : "T"}
                                              </p>
                                            </td>
                                          </tr>
                                        </tbody>
                                      )
                                    );
                                  })()}
                                </table>

                                {productDetails ? (
                                  productWiseOrder.map((products) => (
                                    <table
                                      style={{
                                        border: "none",
                                        marginBottom: "10px",
                                      }}
                                    >
                                      {productDetails && (
                                        <tr style={{ border: "none" }}>
                                          <td
                                            rowSpan={
                                              products.orders.length / 2 + 2
                                            }
                                            style={{
                                              borderBottom: "0px",
                                              borderTop: "0px",
                                              width: "29%",
                                            }}
                                          >
                                            <div
                                              style={{
                                                border: "1px solid gray",
                                                borderRadius: "5px",
                                                padding: "10px 0px",
                                              }}
                                            >
                                              <div
                                                className="reelForFormat2"
                                                style={{
                                                  marginLeft: "5px",
                                                  display: "flex",
                                                  flexDirection: "row",
                                                  fontSize: "13px",
                                                  fontWeight: "bold",
                                                }}
                                              >
                                                <div>GSM: {products.gsm}</div>
                                                {products?.burst_factor && (
                                                  <div
                                                    style={{
                                                      marginLeft: "10px",
                                                    }}
                                                  >
                                                    BF:{products?.burst_factor}
                                                  </div>
                                                )}
                                                {products.moisture ? (
                                                  <div
                                                    style={{
                                                      marginLeft: "10px",
                                                    }}
                                                  >
                                                    Moisture:{" "}
                                                    {products.moisture}
                                                  </div>
                                                ) : (
                                                  ""
                                                )}
                                              </div>
                                              <div
                                                className="reelForFormat2"
                                                style={{
                                                  textAlign: "left",
                                                  marginLeft: "5px",
                                                  display: "flex",
                                                  flexDirection: "column",
                                                  fontSize: "13px",
                                                  fontWeight: "bold",
                                                }}
                                              >
                                                <div>
                                                  Quality: {products.quality}
                                                </div>
                                                <div>
                                                  Grade: {products.grade}
                                                </div>
                                              </div>
                                            </div>
                                          </td>
                                        </tr>
                                      )}
                                      <tr style={{ border: "none" }}>
                                        <td
                                          style={{
                                            border: "none",
                                            verticalAlign: "top",
                                          }}
                                        >
                                          <table style={{ border: "none" }}>
                                            {products.orders.map(
                                              (item, index) => (
                                                <div>
                                                  {index % 2 == 0 && (
                                                    <tr
                                                      style={{
                                                        border: "none",
                                                      }}
                                                    >
                                                      <td
                                                        style={{
                                                          border: "none",
                                                          textAlign: "left",
                                                        }}
                                                      >
                                                        {item && (
                                                          <div
                                                            style={{
                                                              display: "flex",
                                                              flexDirection:
                                                                "row",
                                                            }}
                                                          >
                                                            <div>
                                                              {poDetails &&
                                                                item.type.toLowerCase() ==
                                                                "order" && (
                                                                  <p
                                                                    style={{
                                                                      fontSize:
                                                                        "13px",
                                                                      fontWeight:
                                                                        "bold",
                                                                    }}
                                                                  >
                                                                    PO:{" "}
                                                                    {item.pono}
                                                                  </p>
                                                                )}
                                                              <p
                                                                style={{
                                                                  fontSize:
                                                                    "13px",
                                                                  fontWeight:
                                                                    "bold",
                                                                }}
                                                              >
                                                                {(customerDetails
                                                                  ? item?.customername +
                                                                  " "
                                                                  : "") +
                                                                  item?.size +
                                                                  " " +
                                                                  item.group +
                                                                  " (" +
                                                                  item.totalSheet +
                                                                  " S" +
                                                                  ", " +
                                                                  item.fulfilledWeight +
                                                                  " " +
                                                                  item.fWeightUnit +
                                                                  ")"}
                                                              </p>
                                                              {consigneeDetails &&
                                                                item.type.toLowerCase() ==
                                                                "order" && (
                                                                  <p
                                                                    style={{
                                                                      fontSize:
                                                                        "13px",
                                                                      fontWeight:
                                                                        "bold",
                                                                    }}
                                                                  >
                                                                    Consignee:{" "}
                                                                    {
                                                                      item.consignee_name
                                                                    }
                                                                  </p>
                                                                )}
                                                              {orderRemarks &&
                                                                item?.remarks.map(
                                                                  (remark) => (
                                                                    <p
                                                                      style={{
                                                                        fontSize:
                                                                          "13px",
                                                                        fontWeight:
                                                                          "bold",
                                                                      }}
                                                                    >
                                                                      {remark
                                                                        ? "Remarks: " +
                                                                        remark
                                                                        : ""}
                                                                    </p>
                                                                  )
                                                                )}
                                                            </div>
                                                          </div>
                                                        )}
                                                      </td>
                                                    </tr>
                                                  )}{" "}
                                                </div>
                                              )
                                            )}{" "}
                                          </table>
                                        </td>
                                        <td
                                          style={{
                                            border: "none",
                                            verticalAlign: "top",
                                          }}
                                        >
                                          <table style={{ border: "none" }}>
                                            {products.orders.map(
                                              (item, index) => (
                                                <div>
                                                  {index % 2 == 1 && (
                                                    <tr
                                                      style={{
                                                        border: "none",
                                                      }}
                                                    >
                                                      <td
                                                        style={{
                                                          border: "none",
                                                          textAlign: "left",
                                                        }}
                                                      >
                                                        {item && (
                                                          <div
                                                            style={{
                                                              display: "flex",
                                                              flexDirection:
                                                                "row",
                                                            }}
                                                          >
                                                            <div>
                                                              {poDetails &&
                                                                item.type.toLowerCase() ==
                                                                "order" && (
                                                                  <p
                                                                    style={{
                                                                      fontSize:
                                                                        "13px",
                                                                      fontWeight:
                                                                        "bold",
                                                                    }}
                                                                  >
                                                                    PO:{" "}
                                                                    {item.pono}
                                                                  </p>
                                                                )}
                                                              <p
                                                                style={{
                                                                  fontSize:
                                                                    "13px",
                                                                  fontWeight:
                                                                    "bold",
                                                                }}
                                                              >
                                                                {(customerDetails
                                                                  ? item?.customername +
                                                                  " "
                                                                  : "") +
                                                                  item?.size +
                                                                  " " +
                                                                  item.group +
                                                                  "(" +
                                                                  item.totalSheet +
                                                                  " S" +
                                                                  ", " +
                                                                  item.fulfilledWeight +
                                                                  " " +
                                                                  item.fWeightUnit +
                                                                  ")"}
                                                              </p>
                                                              {consigneeDetails &&
                                                                item.type.toLowerCase() ==
                                                                "order" && (
                                                                  <p
                                                                    style={{
                                                                      fontSize:
                                                                        "13px",
                                                                      fontWeight:
                                                                        "bold",
                                                                    }}
                                                                  >
                                                                    Consignee:{" "}
                                                                    {
                                                                      item.consignee_name
                                                                    }
                                                                  </p>
                                                                )}
                                                              {orderRemarks &&
                                                                item?.remarks.map(
                                                                  (remark) => (
                                                                    <p
                                                                      style={{
                                                                        fontSize:
                                                                          "13px",
                                                                        fontWeight:
                                                                          "bold",
                                                                      }}
                                                                    >
                                                                      {remark
                                                                        ? "Remarks: " +
                                                                        remark
                                                                        : ""}
                                                                    </p>
                                                                  )
                                                                )}
                                                            </div>
                                                          </div>
                                                        )}
                                                      </td>
                                                    </tr>
                                                  )}{" "}
                                                </div>
                                              )
                                            )}{" "}
                                          </table>
                                        </td>
                                      </tr>
                                    </table>
                                  ))
                                ) : customerDetails ? (
                                  <table
                                    style={{
                                      border: "none",
                                      marginBottom: "40px",
                                    }}
                                  >
                                    <tr style={{ border: "none" }}>
                                      <td
                                        style={{
                                          border: "none",
                                          verticalAlign: "top",
                                        }}
                                      >
                                        <table style={{ border: "none" }}>
                                          {customerWiseOrder.map(
                                            (item, index) => (
                                              <div>
                                                {index % 2 == 0 && (
                                                  <tr
                                                    style={{ border: "none" }}
                                                  >
                                                    <td
                                                      style={{
                                                        border: "none",
                                                        textAlign: "left",
                                                      }}
                                                    >
                                                      {item &&
                                                        customerDetails && (
                                                          <div
                                                            style={{
                                                              display: "flex",
                                                              flexDirection:
                                                                "row",
                                                            }}
                                                          >
                                                            <div>
                                                              {poDetails &&
                                                                item.type.toLowerCase() ==
                                                                "order" && (
                                                                  <p
                                                                    style={{
                                                                      fontSize:
                                                                        "13px",
                                                                      fontWeight:
                                                                        "bold",
                                                                    }}
                                                                  >
                                                                    PO:{" "}
                                                                    {item.pono}
                                                                  </p>
                                                                )}
                                                              <p
                                                                style={{
                                                                  fontSize:
                                                                    "13px",
                                                                  fontWeight:
                                                                    "bold",
                                                                }}
                                                              >
                                                                {(customerDetails
                                                                  ? item?.customername +
                                                                  " "
                                                                  : "") +
                                                                  item?.size +
                                                                  " " +
                                                                  item.group +
                                                                  "(" +
                                                                  item.totalSheet +
                                                                  " S" +
                                                                  ", " +
                                                                  item.fulfilledWeight +
                                                                  " " +
                                                                  item.fWeightUnit +
                                                                  ")"}
                                                              </p>
                                                              {consigneeDetails &&
                                                                item.type.toLowerCase() ==
                                                                "order" && (
                                                                  <p
                                                                    style={{
                                                                      fontSize:
                                                                        "13px",
                                                                      fontWeight:
                                                                        "bold",
                                                                    }}
                                                                  >
                                                                    Consignee:{" "}
                                                                    {
                                                                      item.consignee_name
                                                                    }
                                                                  </p>
                                                                )}
                                                              {orderRemarks &&
                                                                item?.remarks.map(
                                                                  (remark) => (
                                                                    <p
                                                                      style={{
                                                                        fontSize:
                                                                          "13px",
                                                                        fontWeight:
                                                                          "bold",
                                                                      }}
                                                                    >
                                                                      {remark
                                                                        ? "Remarks: " +
                                                                        remark
                                                                        : ""}
                                                                    </p>
                                                                  )
                                                                )}
                                                            </div>
                                                          </div>
                                                        )}
                                                    </td>
                                                  </tr>
                                                )}{" "}
                                              </div>
                                            )
                                          )}{" "}
                                        </table>
                                      </td>
                                      <td
                                        style={{
                                          border: "none",
                                          verticalAlign: "top",
                                        }}
                                      >
                                        <table style={{ border: "none" }}>
                                          {customerWiseOrder.map(
                                            (item, index) => (
                                              <div>
                                                {index % 2 == 1 && (
                                                  <tr
                                                    style={{ border: "none" }}
                                                  >
                                                    <td
                                                      style={{
                                                        border: "none",
                                                        textAlign: "left",
                                                      }}
                                                    >
                                                      {item &&
                                                        customerDetails && (
                                                          <div
                                                            style={{
                                                              display: "flex",
                                                              flexDirection:
                                                                "row",
                                                            }}
                                                          >
                                                            <div>
                                                              {poDetails &&
                                                                item.type.toLowerCase() ==
                                                                "order" && (
                                                                  <p
                                                                    style={{
                                                                      fontSize:
                                                                        "13px",
                                                                      fontWeight:
                                                                        "bold",
                                                                    }}
                                                                  >
                                                                    PO:{" "}
                                                                    {item.pono}
                                                                  </p>
                                                                )}
                                                              <p
                                                                style={{
                                                                  fontSize:
                                                                    "13px",
                                                                  fontWeight:
                                                                    "bold",
                                                                }}
                                                              >
                                                                {(customerDetails
                                                                  ? item?.customername +
                                                                  " "
                                                                  : "") +
                                                                  item?.size +
                                                                  " " +
                                                                  item.group +
                                                                  "(" +
                                                                  item.totalSheet +
                                                                  " S" +
                                                                  ", " +
                                                                  item.fulfilledWeight +
                                                                  " " +
                                                                  item.fWeightUnit +
                                                                  ")"}
                                                              </p>
                                                              {consigneeDetails &&
                                                                item.type.toLowerCase() ==
                                                                "order" && (
                                                                  <p
                                                                    style={{
                                                                      fontSize:
                                                                        "13px",
                                                                      fontWeight:
                                                                        "bold",
                                                                    }}
                                                                  >
                                                                    Consignee:{" "}
                                                                    {
                                                                      item.consignee_name
                                                                    }
                                                                  </p>
                                                                )}
                                                              {orderRemarks &&
                                                                item?.remarks.map(
                                                                  (remark) => (
                                                                    <p
                                                                      style={{
                                                                        fontSize:
                                                                          "13px",
                                                                        fontWeight:
                                                                          "bold",
                                                                      }}
                                                                    >
                                                                      {remark
                                                                        ? "Remarks: " +
                                                                        remark
                                                                        : ""}
                                                                    </p>
                                                                  )
                                                                )}
                                                            </div>
                                                          </div>
                                                        )}
                                                    </td>
                                                  </tr>
                                                )}{" "}
                                              </div>
                                            )
                                          )}{" "}
                                        </table>
                                      </td>
                                    </tr>
                                  </table>
                                ) : null}
                              </div>
                            </ExportTableForm1>
                          </div>
                        )}
                      </div>
                    </Layout>
                  </OtherPages>
                </PrintData>
              </Col>
            ) : (
              <Col span={16}>
                <PrintData id="export-content" style={{ width: "100%" }}>
                  <OtherPages style={{ width: "100%" }}>
                    <Layout
                      style={{
                        backgroundColor: "#ffffff",
                        marginTop: "-40px",
                        width: "100%",
                      }}
                    >
                      <div ref={printRef} style={{ width: "100%" }}>
                        <div style={{ padding: "20px" }}>
                          <CardShimmerStyle>
                            <div style={{ width: "100%", display: "flex" }}>
                              <div
                                style={{
                                  flexDirection: "row",
                                  display: "flex",
                                  width: "100%",
                                }}
                              >
                                <Skeleton.Button
                                  active={true}
                                  style={{ height: "80px" }}
                                ></Skeleton.Button>
                              </div>
                            </div>
                          </CardShimmerStyle>
                        </div>
                        <div style={{ padding: "20px" }}>
                          <CardShimmerStyle style={{ marginBottom: "30px" }}>
                            <div style={{ width: "100%", display: "flex" }}>
                              <div
                                style={{
                                  flexDirection: "row",
                                  display: "flex",
                                  width: "100%",
                                }}
                              >
                                <Skeleton.Button
                                  active={true}
                                  style={{ height: "50px" }}
                                ></Skeleton.Button>
                              </div>
                            </div>
                          </CardShimmerStyle>
                          <TableLayoutData>
                            <div className="tableDataFormat">
                              <TableShimmer
                                header={shimmerHeader}
                                showHeader={false}
                                rows={8}
                                minHeight={"10px"}
                              />
                            </div>
                          </TableLayoutData>
                        </div>
                      </div>
                    </Layout>
                  </OtherPages>
                </PrintData>
              </Col>
            )}
          </Row>
        </Layout>
      )}
    </RightLayoutContainer>
  );
};
export default PrintSheetJobCardDetails;
